import React, { useState, useEffect, useRef } from 'react';
import { BsArrowLeft, BsArrowRight, BsCheck, BsCopy, BsLockFill } from "react-icons/bs";
import { allCountries } from 'utils/countryList';
import { allCryptoCurrency , allBlockChainNetwork } from 'utils/cryptoCurrenctList';
import bm2payLogo from "./assets/img/bm2pay.svg";
import lightningChecksLogo  from "./assets/img/mainlogo.png";
import paxumLogo  from "./assets/img/paxum.png";
import { createPayment, getCheckOutDetails, getClient , getWalletDetails ,getCryptoPayout , getFiatPayout ,  generateCheckoutLink, checkLink, getCheckOutDetailsCheckoutPage } from "api/clients";
import { useParams } from 'react-router-dom';
import Link from 'antd/es/typography/Link';
import toast from 'react-hot-toast';
import pix from 'assets/img/payment-clients/pix.png';
import { AiFillCheckCircle, AiFillCloseCircle, AiFillExclamationCircle, AiOutlineBank, AiOutlineCheck, AiOutlineClose, AiOutlineCreditCard, AiOutlineDownload, AiOutlineLoading3Quarters, AiOutlineLock, AiOutlineQrcode, AiOutlineUpload, AiOutlineUser } from 'react-icons/ai';
import { Modal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/modal";
import Card from "components/card";
import { useDisclosure } from "@chakra-ui/hooks";
import DivLoader from "components/divloader/DivLoader";
import sampleImage  from "assets/img/payment-clients/placeholder.png";
import { validate } from 'uuid';
import { getCurrencySymbol , currencyCodes} from "utils/currencyList"; 
import { stubTrue } from 'lodash';
import { QRCodeCanvas } from "qrcode.react";
import { Select as AntSelect } from "antd";


interface PaymentData {
    first_name:string;
    middle_name:string;
    last_name:string;
    name: string;
    email: string;
    phone: string;
    cardHolderName: string;
    cardNumber: string;
    expiry: string;
    cvv: string;
    address: string;
    state: string;
    city: string;
    country: string;
    postalCode: string;
}

interface PixPaymentData {
    first_name:string;
    last_name:string;
    identification_number: string;
    identification_type: string;
}

interface CryptoPaymentData {
    first_name:string;
    last_name:string;
    email: string;
    phone: string;
    country: string;
    crypto_currency : string;
    blockchain_network : string;
}

interface CryptoPayoutPaymentData {
    first_name:string;
    last_name:string;
    email: string;
    phone: string;
    country: string;
    city: string;
    address: string;
    state: string;
    postal_code: string;
    crypto_currency : string;
    blockchain_network : string;
    wallet_address : string;
}

interface FiatPayoutPaymentData {
    first_name:string;
    last_name:string;
    email: string;
    phone: string;
    country: string;
    city: string;
    address: string;
    state: string;
    postal_code: string;
    document_number : string;
    bank_account : string;
    bank_code : string;
    account_type:string;
    currency:string;
    fiat_currency:string;
    blockchain_symbol:string;
    token_symbol:string;
}

const hostname = window.location.hostname;
const logos : any = {
    'gateway-dev.lightningchecks.com': lightningChecksLogo,
    'gateway.lightningchecks.com': lightningChecksLogo,
    'testing.lightningchecks.com': lightningChecksLogo,
    'gateway-dev.bm2pay.com': bm2payLogo,
    'gateway.bm2pay.com': bm2payLogo,
    'gateway-stagging.bm2pay.com': bm2payLogo,
    'pay.paxum.com': paxumLogo,
};
const mainlogo = (
    <img
        style={{ height: "auto", width: hostname === "pay.paxum.com" ? "80px" : "30px" }}
        src={logos[hostname] || bm2payLogo}
        className="ml-2"
        alt="Gateway Image"
    />
);

function CheckoutPage() {
    const { client_id, checkout_id, unique_payment_link_id , internal_tx_id } = useParams()
    const [client_secret,setClientSecret] = useState('');
    const [brandColor, setBrandColor] = useState('#2020e4');
    const [primaryColor, setPrimaryColor] = useState('#2020e4');
    const [secondaryColor, setSecondaryColor] = useState('#422AFB');
    const [buttonColor, setButtonColor] = useState('#5757ac');
    const [style, setStyle] = useState("rounded");
    const [selectedFont, setSelectedFont] = useState("'Poppins'");
    const [showForm,setShowForm] = useState(false);
    const [paymentType,setPaymentType] = useState('one-time-payment');
    const [imagePreview, setImagePreview] = useState(sampleImage);
    const [businessName,setBusinessName] = useState("");
    const [paymentData, setPaymentData] = useState<PaymentData>({
        first_name: "",
        middle_name: "",
        last_name: "",
        name: "",
        email: "",
        phone: "",
        cardHolderName : '',
        cardNumber: '',
        expiry : '',
        cvv : '',
        address : '',
        state : '',
        city : '',
        country : 'CA',
        postalCode : ''
    });
    const [pixPaymentData, setPixPaymentData] = useState<PixPaymentData>({
        first_name: "",
        last_name: "",
        identification_number: "",
        identification_type: ""
    });
    const [cryptoPaymentData, setCryptoPaymentData] = useState<CryptoPaymentData>({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        country : 'CA',
        crypto_currency : "",
        blockchain_network : ""
    });
    const [cryptoPayoutPaymentData, setCryptoPayoutPaymentData] = useState<CryptoPayoutPaymentData>({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        country : 'CA',
        city : '',
        address : '',
        state : '',
        postal_code : '',
        crypto_currency : "",
        blockchain_network : "",
        wallet_address : ""
    });
    const [fiatPayoutPaymentData, setFiatPayoutPaymentData] = useState<FiatPayoutPaymentData>({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        country : 'CA',
        city : '',
        address : '',
        state : '',
        postal_code : '',
        document_number : "",
        bank_account : "",
        bank_code : "",
        account_type : "",
        currency : "",
        fiat_currency : "",
        blockchain_symbol : "",
        token_symbol : "",
    });
    const [timeLeft, setTimeLeft] = useState(0); 
    const [isExpired, setIsExpired] = useState(false);
    const [selectedCurrency, setSelectedCurrency] = useState<string>("USD");
    const [amount, setAmount] = useState("");
    const [amountNotSet, setAmountNotSet] = useState(false);
    const [targetDateTime, setTargetDateTime] = useState(null);
    const [expiresAt, setExpiresAt] = useState(null);
    const [showPreview,setShowPreview] = useState(true);
    const [successPreview,setSuccessPreview] = useState(false);
    const [pendingPreview,setPendingPreview] = useState(false);
    const [failedPreview,setFailedPreview] = useState(false);
    const [isProcess, setIsProcess] = useState(false);
    const [isUsed, setIsUsed] = useState(false);    
    const [checkoutPaymentMethod,setCheckoutPaymentMethod] = useState(null);

    const { isOpen, onOpen, onClose } = useDisclosure();
    const [isLoading, setIsLoading] = useState<boolean>();
    const [paymentStatus, setPaymentStatus] = useState<'idle' | 'processing' | 'approved' | 'failed' | 'pending' | 'declined' | 'cancelled' | 'rejected' | 'errored'>('idle');
    const [isEditing, setIsEditing] = useState(false);
    const inputRef = useRef(null);
    const [paymentError,setPaymentError] = useState("");
    const [oneErrors, setOneErrors] = useState<Record<string, string>>({});
    const [pixErrors, setPixErrors] = useState<Record<string, string>>({});
    const [cryptoErrors, setCryptoErrors] = useState<Record<string, string>>({});
    const [cryptoPayoutErrors, setCryptoPayoutErrors] = useState<Record<string, string>>({});
    const [fiatPayoutErrors, setFiatPayoutErrors] = useState<Record<string, string>>({});
    const [ipAddress,setIpAddress] = useState("0.0.0.0");
    const [paymentCompeleted,setPaymentCompleted] = useState(false);
    const [amountError,setAmountError] = useState("");
    const [isMultiOption,setIsMultiOption] = useState(true);
    const [initialLoading,setInitialLoading] = useState(true);
    const [payinNotEnabled,setPayinNotEnabled] = useState(false);
    const [cryptoPayinNotEnabled,setCryptoPayinNotEnabled] = useState(false);
    const [cryptoPayoutNotEnabled,setCryptoPayoutNotEnabled] = useState(false);
    const [fiatPayoutNotEnabled,setFiatPayoutNotEnabled] = useState(false);
    const [return_url,setReturnUrl] = useState("");
    const [callback_url,setCallbackUrl] = useState("");
    const [addressPreview,setAddressPreview] = useState(false);
    const [blockChainNetworks,setBlockChainNetworks] = useState([]);
    const [selectedCryptoCurrency,setSelectedCryptoCurrency] = useState("")
    const [cryptoAddress,setCryptoAddress] = useState("1FfmbHfnpaZjKFvyi1okTjJJusN455paPH")
    const [cryptoAmount,setCryptoAmount] = useState("0.00154568")
    const [copiedAddress, setCopiedAddress] = useState(false);
    const [copiedAmount, setCopiedAmount] = useState(false);
    const [currentFiatAmount, setCurrentFiatAmount] = useState("123456");
    const [qrCode, setQrCode] = useState("");
    const [allPaymentDisabled, setAllPaymentDisabled] = useState(false);

    const [disabledMethods, setDisabledMethods] = useState({
        payin: false,
        cryptoPayin: false,
        cryptoPayout: false,
        fiatPayout: false,
    });


    const [step, setStep] = useState<1 | 2>(1);

    const handleCopyAddress = () => {
        navigator.clipboard.writeText(cryptoAddress);
        setCopiedAddress(true);

        setTimeout(() => {
            setCopiedAddress(false);
        }, 2000);
    };

    const handleCopyAmount = () => {
        navigator.clipboard.writeText(cryptoAmount);
        setCopiedAmount(true);

        setTimeout(() => {
            setCopiedAmount(false);
        }, 2000);
    };

    const handleEdit = () => {
        setIsEditing(true);
        setTimeout(() => inputRef.current?.focus(), 0);
    };

    const validateOneTimeFields = () => {
        const newErrors: Record<string, string> = {};
        if (!paymentData.first_name.trim()) newErrors.first_name = 'Field is required';
        if (!paymentData.middle_name.trim()) newErrors.middle_name = 'Field is required';
        if (!paymentData.last_name.trim()) newErrors.last_name = 'Field is required';
        if (!paymentData.email.trim()) newErrors.email = 'Field is required';
        // if (!/^\S+@\S+\.\S+$/.test(paymentData.email)) newErrors.email = 'Enter a valid email';
        if (!paymentData.phone.trim()) newErrors.phone = 'Field is required';
        if (!paymentData.cardHolderName.trim()) newErrors.cardHolderName = 'Field is required';
        if (!paymentData.cardNumber.trim()) newErrors.cardNumber = 'Field is required';
        // if (!/^\d{16}$/.test(paymentData.cardNumber)) newErrors.cardNumber = 'Enter a valid card number';
        if (!paymentData.expiry.trim()) newErrors.expiry = 'Field is required';
        if (!paymentData.cvv.trim()) newErrors.cvv = 'Field is required';
        // if (!/^\d{3}$/.test(paymentData.cvv)) newErrors.cvv = 'Enter a valid CVV';
        if (!paymentData.address.trim()) newErrors.address = 'Field is required';
        if (!paymentData.state.trim()) newErrors.state = 'Field is required';
        if (!paymentData.city.trim()) newErrors.city = 'Field is required';
        if (!paymentData.country.trim()) newErrors.country = 'Field is required';
        if (!paymentData.postalCode.trim()) newErrors.postalCode = 'Field is required';
       
        if(amountNotSet && amount === null) {
            setAmountError("Field is required");
            newErrors.amount = "Field is required"
        } else {
            delete newErrors.amount; 
        }
    
        setOneErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleAmountSet = (field : any, value :any) => {
        setAmount(value);
        setCryptoAmount(value);
        setIsEditing(true);
        if(value == "") {
            setAmountError("Field is required");
        } else {
            setAmountError("");
        }
    }

    const validatePixFields = () => {
        const newErrors: Record<string, string> = {};
        if (!pixPaymentData.first_name.trim()) newErrors.first_name = 'Field is required';
        if (!pixPaymentData.last_name.trim()) newErrors.last_name = 'Field is required';
        if (!pixPaymentData.identification_number.trim()) newErrors.identification_number = 'Field is required';
        if (!pixPaymentData.identification_type.trim()) newErrors.identification_type = 'Field is required';
        if(amountNotSet && amount === null) {
            setAmountError("Field is required");
            newErrors.amount = "Field is required"
        } else {
            delete newErrors.amount; 
        }
        setPixErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateCryptoFields = () => {
        const newErrors: Record<string, string> = {};
        if (!cryptoPaymentData.first_name.trim()) newErrors.first_name = 'Field is required';
        if (!cryptoPaymentData.last_name.trim()) newErrors.last_name = 'Field is required';
        if (!cryptoPaymentData.email.trim()) newErrors.email = 'Field is required';
        if (!cryptoPaymentData.phone.trim()) newErrors.phone = 'Field is required';
        if (!cryptoPaymentData.crypto_currency.trim()) newErrors.crypto_currency = 'Field is required';
        if (!cryptoPaymentData.blockchain_network.trim()) newErrors.blockchain_network = 'Field is required';
        if(amountNotSet && amount === null) {
            setAmountError("Field is required");
            newErrors.amount = "Field is required"
        } else {
            delete newErrors.amount; 
        }
        setCryptoErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateCryptoPayoutFields = () => {
        const newErrors: Record<string, string> = {};
        if (!cryptoPayoutPaymentData.first_name.trim()) newErrors.first_name = 'Field is required';
        if (!cryptoPayoutPaymentData.last_name.trim()) newErrors.last_name = 'Field is required';
        if (!cryptoPayoutPaymentData.email.trim()) newErrors.email = 'Field is required';
        if (!cryptoPayoutPaymentData.phone.trim()) newErrors.phone = 'Field is required';
        if (!cryptoPayoutPaymentData.city.trim()) newErrors.city = 'Field is required';
        if (!cryptoPayoutPaymentData.address.trim()) newErrors.address = 'Field is required';
        if (!cryptoPayoutPaymentData.state.trim()) newErrors.state = 'Field is required';
        if (!cryptoPayoutPaymentData.postal_code.trim()) newErrors.postal_code = 'Field is required';
        if (!cryptoPayoutPaymentData.crypto_currency.trim()) newErrors.crypto_currency = 'Field is required';
        if (!cryptoPayoutPaymentData.blockchain_network.trim()) newErrors.blockchain_network = 'Field is required';
        if (!cryptoPayoutPaymentData.wallet_address.trim()) newErrors.wallet_address = 'Field is required';
        if(amountNotSet && amount === null) {
            setAmountError("Field is required");
            newErrors.amount = "Field is required"
        } else {
            delete newErrors.amount; 
        }
        setCryptoPayoutErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateFiatPayoutFields = () => {
        const newErrors: Record<string, string> = {};
        if (!fiatPayoutPaymentData.first_name.trim()) newErrors.first_name = 'Field is required';
        if (!fiatPayoutPaymentData.last_name.trim()) newErrors.last_name = 'Field is required';
        if (!fiatPayoutPaymentData.email.trim()) newErrors.email = 'Field is required';
        if (!fiatPayoutPaymentData.phone.trim()) newErrors.phone = 'Field is required';
        if (!fiatPayoutPaymentData.city.trim()) newErrors.city = 'Field is required';
        if (!fiatPayoutPaymentData.address.trim()) newErrors.address = 'Field is required';
        if (!fiatPayoutPaymentData.state.trim()) newErrors.state = 'Field is required';
        if (!fiatPayoutPaymentData.postal_code.trim()) newErrors.postal_code = 'Field is required';
        if(amountNotSet && amount === null) {
            setAmountError("Field is required");
            newErrors.amount = "Field is required"
        } else {
            delete newErrors.amount; 
        }
        setFiatPayoutErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleOneFieldChange = (field : any, value :any) => {
        let updatedValue = value;
        if (field === 'phone') {
            const numericValue = value.replace(/\D/g, '');
            if (value !== numericValue && numericValue === '') {
                return;
            }
            updatedValue = numericValue;
        }
        setPaymentData({ ...paymentData, [field]: updatedValue  });
        if(updatedValue  != "") {
            setOneErrors({ ...oneErrors, [field]: '' });
        } else {
            setOneErrors({ ...oneErrors, [field]: 'Field is required' });
        }
    };

    const handlePixFieldChange = (field : any, value :any) => {
        setPixPaymentData({ ...pixPaymentData, [field]: value });
        if(value != "") {
            setPixErrors({ ...pixErrors, [field]: '' });
        } else {
            setPixErrors({ ...pixErrors, [field]: 'Field is required' });
        }
    };

    const handleCryptoFieldChange = (field : any, value :any) => {
        let updatedValue = value;
        if (field === 'phone') {
            const numericValue = value.replace(/\D/g, '');
            if (value !== numericValue && numericValue === '') {
                return;
            }
            updatedValue = numericValue;
        }
        setCryptoPaymentData({ ...cryptoPaymentData, [field]: updatedValue  });
        if(updatedValue  != "") {
            setCryptoErrors({ ...cryptoErrors, [field]: '' });
        } else {
            setCryptoErrors({ ...cryptoErrors, [field]: 'Field is required' });
        }
    };

    const handleCryptoPayoutFieldChange = (field : any, value :any) => {
        let updatedValue = value;
        if (field === 'phone') {
            const numericValue = value.replace(/\D/g, '');
            if (value !== numericValue && numericValue === '') {
                return;
            }
            updatedValue = numericValue;
        }
        setCryptoPayoutPaymentData({ ...cryptoPayoutPaymentData, [field]: updatedValue  });
        if(updatedValue  != "") {
            setCryptoPayoutErrors({ ...cryptoPayoutErrors, [field]: '' });
        } else {
            setCryptoPayoutErrors({ ...cryptoPayoutErrors, [field]: 'Field is required' });
        }
    };

    const handleFiatPayoutFieldChange = (field : any, value :any) => {
        let updatedValue = value;
        if (field === 'phone') {
            const numericValue = value.replace(/\D/g, '');
            if (value !== numericValue && numericValue === '') {
                return;
            }
            updatedValue = numericValue;
        }
        setFiatPayoutPaymentData({ ...fiatPayoutPaymentData, [field]: updatedValue  });
        if(updatedValue  != "") {
            setFiatPayoutErrors({ ...fiatPayoutErrors, [field]: '' });
        } else {
            setFiatPayoutErrors({ ...fiatPayoutErrors, [field]: 'Field is required' });
        }
    };

    useEffect(() => {
        if (targetDateTime) {
            const targetDate: any = new Date(targetDateTime); 
            
    
            let intervalId: NodeJS.Timeout; 
            
            const updateTimeLeft = () => {
                
                const currentTime: any = new Date();
                
                const difference = targetDate - currentTime;
    
                if (difference <= 0) {
                    setIsExpired(true);
                    setTimeLeft(0);
                    clearInterval(intervalId); 
                    // generateNewLink();
                    if(!paymentCompeleted) {
                        onOpen();
                    }
                } else {
                    setTimeLeft(difference);
                }
            };
    
            updateTimeLeft(); // Initial call
            intervalId = setInterval(updateTimeLeft, 1000); 
    
            return () => clearInterval(intervalId); 
        }
    }, [targetDateTime]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (client_id) {
                   
                    const checkLinkResponse = await checkLink(client_id, checkout_id, unique_payment_link_id);
                    setPaymentData((prevData) => ({ ...prevData, name: checkLinkResponse?.data?.client_name }));                   
                    const isUsed = checkLinkResponse?.data?.is_used;
                    setIsUsed(isUsed);
                    const client_secret = checkLinkResponse?.data?.client_secret ?? "";
                    setClientSecret(client_secret);
                    
                    const checkoutResponse = await getCheckOutDetailsCheckoutPage(checkout_id, client_id, client_secret);
                    const responseData = checkoutResponse?.data;
                    if(responseData?.brand_color) {
                        setBrandColor(responseData?.brand_color); 
                    }
                    if(responseData?.primary_color) {
                        setPrimaryColor(responseData?.primary_color);
                    }
                    if(responseData?.secondary_color) {
                        setSecondaryColor(responseData?.secondary_color);
                    }
                    if(responseData?.button_color) {
                        setButtonColor(responseData?.button_color);
                    }
                    setStyle(responseData?.brand_style);
                    setSelectedFont(responseData?.brand_font);
                    setSelectedCurrency(checkLinkResponse?.data?.currency);
                    setSelectedCryptoCurrency(checkLinkResponse?.data?.currency);

                    if (!isUsed) {
                        if(checkLinkResponse?.data?.customer) {
                            const cus_data = checkLinkResponse?.data?.customer;
                            setPaymentData((prevData) => ({ 
                                ...prevData, 
                                first_name: cus_data.first_name,
                                middle_name: cus_data.middle_name,
                                last_name: cus_data.last_name,
                                email: cus_data.email,
                                phone: cus_data.phone,
                                address : cus_data.address,
                                state : cus_data.state,
                                city : cus_data.city,
                                country : cus_data.country,
                                postalCode :cus_data.postal_code 
                            }));                   
                        }

                        if(checkLinkResponse?.data?.payment_data) {
                            const pay_data = checkLinkResponse?.data?.payment_data;
                            setPaymentData((prevData) => ({ 
                                ...prevData, 
                                cardHolderName : pay_data.card_holder_name,
                                cardNumber: pay_data.card_number,
                                expiry : pay_data.card_expiry_month+ " / "+pay_data.card_expiry_year,
                                cvv : pay_data.card_cvv
                            }));                   
                        }
                        if (checkLinkResponse?.data?.currency) {
                            setSelectedCurrency(checkLinkResponse?.data?.currency)
                            setCryptoPaymentData((prevData) => ({ ...prevData, crypto_currency: checkLinkResponse?.data?.currency }));  
                            handleCryptoCurrencyChange(checkLinkResponse?.data?.currency , "api")
                        }    
                        if (checkLinkResponse?.data?.network) {
                            setCryptoPaymentData((prevData) => ({ ...prevData, blockchain_network: checkLinkResponse?.data?.network }));  
                        }     
              
                        setAmount(checkLinkResponse?.data?.amount);
                        setCryptoAmount(checkLinkResponse?.data?.amount);

                        if (responseData?.business_name) {
                            setBusinessName(responseData.business_name);
                        }
                        if (responseData?.business_logo) {
                            setImagePreview("data:image/jpeg;base64,"+responseData.business_logo);
                        }

                        if (checkLinkResponse?.data?.amount == null) {
                            setAmountNotSet(true);
                        }

                        if(checkLinkResponse?.data?.return_url != "" || checkLinkResponse?.data?.return_url != "") {
                            setReturnUrl(checkLinkResponse.data.return_url);
                        }

                        if(checkLinkResponse?.data?.callback_url != "" || checkLinkResponse?.data?.callback_url != "") {
                            setCallbackUrl(checkLinkResponse.data.callback_url);
                        }

                        const targetDateFromAPI = new Date(checkLinkResponse?.data?.expires_at);
                        setTargetDateTime(targetDateFromAPI);
                        setExpiresAt(checkLinkResponse?.data?.expires_at);
                        setCheckoutPaymentMethod(checkLinkResponse?.data?.payment_type);
                        if (!localStorage.getItem(unique_payment_link_id)) {
                            localStorage.setItem(unique_payment_link_id, 'no');
                        } else if (localStorage.getItem(unique_payment_link_id) === 'yes') {
                        } else {
                        localStorage.setItem(unique_payment_link_id, 'no');
                        }

                        const data = checkLinkResponse?.data || {};
                        const {
                            payment_type: paymentTypes = [],
                            is_payin_enabled,
                            is_crypto_payin_enabled,
                            is_crypto_payout_enabled,
                            is_fiat_payout_enabled
                        } = data;

                        setDisabledMethods({
                            payin: !data?.is_payin_enabled,
                            cryptoPayin: !data?.is_crypto_payin_enabled,
                            cryptoPayout: !data?.is_crypto_payout_enabled,
                            fiatPayout: !data?.is_fiat_payout_enabled,
                        });


                        const payinData = {
                            payin: is_payin_enabled,
                            cryptoPayin: is_crypto_payin_enabled,
                            cryptoPayout: is_crypto_payout_enabled,
                            fiatPayout: is_fiat_payout_enabled,
                        };

                        const anyPayinEnabled = Object.values(payinData).some(Boolean);

                        setAllPaymentDisabled(!anyPayinEnabled);

                        const setAllPayinFlags = (flags: any) => {
                            setPayinNotEnabled(!!flags.payin);
                            setCryptoPayinNotEnabled(!!flags.cryptoPayin);
                            setCryptoPayoutNotEnabled(!!flags.cryptoPayout);
                            setFiatPayoutNotEnabled(!!flags.fiatPayout);
                        };

                        const showFormOnly = () => {
                            setShowForm(true);
                            setIsMultiOption(false);
                        };

                        const paymentConfig: any = {
                            ONE_TIME: {
                                enabled: is_payin_enabled || is_crypto_payin_enabled || is_crypto_payout_enabled || is_fiat_payout_enabled,
                                handler: () => {
                                setAllPayinFlags(payinData);
                                if (is_payin_enabled) setPaymentType("pix-payment");
                                else if (is_crypto_payin_enabled) setPaymentType("crypto");
                                else if (is_crypto_payout_enabled) setPaymentType("crypto-payout");
                                else if (is_fiat_payout_enabled) setPaymentType("fiat-payout");
                                else setPaymentType("one-time-payment");
                                if (anyPayinEnabled) setIsMultiOption(true);
                                else showFormOnly();
                                },
                            },
                            PIX: {
                                enabled: is_payin_enabled,
                                handler: () => {
                                setPaymentType("pix-payment");
                                setAllPayinFlags(payinData);
                                if (is_payin_enabled) {
                                    setShowForm(true);
                                    setIsMultiOption(false);
                                    setShowPreview(true);
                                    setPayinNotEnabled(false);
                                } else {
                                    setShowPreview(false);
                                    setPayinNotEnabled(true);
                                }
                                },
                            },
                            CRYPTO: {
                                enabled: is_crypto_payin_enabled,
                                handler: () => {
                                setPaymentType("crypto");
                                setAllPayinFlags(payinData);
                                if (is_crypto_payin_enabled) {
                                    setShowForm(true);
                                    setIsMultiOption(false);
                                    setShowPreview(true);
                                    setCryptoPayinNotEnabled(false);
                                } else {
                                    setShowPreview(false);
                                    setCryptoPayinNotEnabled(true);
                                }
                                },
                            },
                            "CRYPTO PAYOUT": {
                                enabled: is_crypto_payout_enabled,
                                handler: () => {
                                setPaymentType("crypto-payout");
                                setAllPayinFlags(payinData);
                                if (is_crypto_payout_enabled) {
                                    setShowForm(true);
                                    setIsMultiOption(false);
                                    setShowPreview(true);
                                    setCryptoPayoutNotEnabled(false);
                                } else {
                                    setShowPreview(false);
                                    setCryptoPayoutNotEnabled(true);
                                }
                                },
                            },
                            "FIAT PAYOUT": {
                                enabled: is_fiat_payout_enabled,
                                handler: () => {
                                setPaymentType("fiat-payout");
                                setAllPayinFlags(payinData);
                                if (is_fiat_payout_enabled) {
                                    setShowForm(true);
                                    setIsMultiOption(false);
                                    setShowPreview(true);
                                    setFiatPayoutNotEnabled(false);
                                } else {
                                    setShowPreview(false);
                                    setFiatPayoutNotEnabled(true);
                                }
                                },
                            },
                            ALL: {
                                enabled: true,
                                handler: () => {
                                setPaymentType("one-time-payment");
                                setAllPayinFlags(payinData);
                                if (anyPayinEnabled) setIsMultiOption(true);
                                else showFormOnly();
                                },
                            },
                        };

                        if (paymentTypes.includes("ALL")) {
                            paymentConfig.ALL.handler();
                            setPaymentType("one-time-payment");
                        } else if (paymentTypes.length === 1) {
                            const singleType = paymentTypes[0];
                            const config = paymentConfig[singleType];
                            if(singleType == 'ONE_TIME') {
                                setPaymentType("one-time-payment");
                            } else if(singleType == 'PIX') {
                                setPaymentType("pix-payment");
                            } else if(singleType == 'CRYPTO') {
                                setPaymentType("crypto");
                            } else if(singleType == 'CRYPTO PAYOUT') {
                                setPaymentType("crypto-payout");
                            } else if(singleType == 'FIAT PAYOUT') {
                                setPaymentType("fiat-payout");
                            } else if(singleType == 'ALL') {
                                setPaymentType("one-time-payment");
                            }
                            setShowForm(true);
                            setIsMultiOption(false);
                            // if (config) config.handler();
                        } else {
                            const has = (type: any) => paymentTypes.includes(type);
                            setAllPayinFlags(payinData);
                            if (has("PIX") && has("ONE_TIME") && has("CRYPTO") && has("CRYPTO PAYOUT") && has("FIAT PAYOUT")) {
                                setPaymentType("one-time-payment");
                                setIsMultiOption(anyPayinEnabled);
                                if (!anyPayinEnabled) showFormOnly();
                            } else if (has("PIX") && has("ONE_TIME") && has("CRYPTO") && has("CRYPTO PAYOUT")) {
                                setPaymentType("one-time-payment");
                                setIsMultiOption(anyPayinEnabled);
                                if (!anyPayinEnabled) showFormOnly();
                            } else if (has("PIX") && has("ONE_TIME") && has("CRYPTO") && has("FIAT PAYOUT")) {
                                setPaymentType("one-time-payment");
                                setIsMultiOption(anyPayinEnabled);
                                if (!anyPayinEnabled) showFormOnly();
                            } else if (has("ONE_TIME") && has("CRYPTO") && has("CRYPTO PAYOUT") && has("FIAT PAYOUT")) {
                                setPaymentType("crypto");
                                setIsMultiOption(anyPayinEnabled);
                                if (!anyPayinEnabled) showFormOnly();
                            } else if (has("PIX") && has("CRYPTO") && has("CRYPTO PAYOUT") && has("FIAT PAYOUT")) {
                                setPaymentType("crypto");
                                setIsMultiOption(anyPayinEnabled);
                                if (!anyPayinEnabled) showFormOnly();
                            } else if (has("PIX") && has("ONE_TIME") && has("CRYPTO")) {
                                setPaymentType("one-time-payment");
                                setIsMultiOption(anyPayinEnabled);
                                if (!anyPayinEnabled) showFormOnly();
                            } else if (has("PIX") && has("ONE_TIME") && has("CRYPTO PAYOUT")) {
                                setPaymentType("one-time-payment");
                                setIsMultiOption(anyPayinEnabled);
                                if (!anyPayinEnabled) showFormOnly();
                            } else if (has("PIX") && has("ONE_TIME") && has("FIAT PAYOUT")) {
                                setPaymentType("one-time-payment");
                                setIsMultiOption(anyPayinEnabled);
                                if (!anyPayinEnabled) showFormOnly();
                            } else if (has("ONE_TIME") && has("CRYPTO") && has("CRYPTO PAYOUT")) {
                                setPaymentType("crypto");
                                setIsMultiOption(anyPayinEnabled);
                                if (!anyPayinEnabled) showFormOnly();
                            } else if (has("CRYPTO") && has("CRYPTO PAYOUT") && has("FIAT PAYOUT")) {
                                setPaymentType("crypto");
                                setIsMultiOption(anyPayinEnabled);
                                if (!anyPayinEnabled) showFormOnly();
                            } else if (has("PIX") && has("ONE_TIME")) {
                                setPaymentType("one-time-payment");
                                setIsMultiOption(is_payin_enabled);
                                if (!is_payin_enabled) showFormOnly();
                            } else if (has("PIX") && has("CRYPTO")) {
                                setPaymentType("crypto");
                                setIsMultiOption(anyPayinEnabled);
                                if (!anyPayinEnabled) showFormOnly();
                            } else if (has("PIX") && has("CRYPTO PAYOUT")) {
                                setPaymentType("crypto-payout");
                                setIsMultiOption(is_payin_enabled || is_crypto_payout_enabled);
                                if (!(is_payin_enabled || is_crypto_payout_enabled)) showFormOnly();
                            } else if (has("PIX") && has("FIAT PAYOUT")) {
                                setPaymentType("fiat-payout");
                                setIsMultiOption(is_payin_enabled || is_fiat_payout_enabled);
                                if (!(is_payin_enabled || is_fiat_payout_enabled)) showFormOnly();
                            } else if (has("ONE_TIME") && has("CRYPTO")) {
                                setPaymentType("one-time-payment");
                                setIsMultiOption(is_crypto_payin_enabled);
                                if (!is_crypto_payin_enabled) showFormOnly();
                            } else if (has("ONE_TIME") && has("CRYPTO PAYOUT")) {
                                setPaymentType("crypto-payout");
                                setIsMultiOption(is_crypto_payout_enabled);
                                if (!is_crypto_payout_enabled) showFormOnly();
                            } else if (has("ONE_TIME") && has("FIAT PAYOUT")) {
                                setPaymentType("fiat-payout");
                                setIsMultiOption(is_fiat_payout_enabled);
                                if (!is_fiat_payout_enabled) showFormOnly();
                            } else if (has("CRYPTO") && has("CRYPTO PAYOUT")) {
                                setPaymentType("crypto");
                                setIsMultiOption(is_crypto_payin_enabled || is_crypto_payout_enabled);
                                if (!(is_crypto_payin_enabled || is_crypto_payout_enabled)) showFormOnly();
                            } else if (has("CRYPTO") && has("FIAT PAYOUT")) {
                                setPaymentType("crypto");
                                setIsMultiOption(is_crypto_payin_enabled || is_fiat_payout_enabled);
                                if (!(is_crypto_payin_enabled || is_fiat_payout_enabled)) showFormOnly();
                            } else if (has("CRYPTO PAYOUT") && has("FIAT PAYOUT")) {
                                setPaymentType("fiat-payout");
                                setIsMultiOption(is_crypto_payout_enabled || is_fiat_payout_enabled);
                                if (!(is_crypto_payout_enabled || is_fiat_payout_enabled)) showFormOnly();
                            } else {
                                setPaymentType("one-time-payment");
                                setIsMultiOption(anyPayinEnabled);
                                if (!anyPayinEnabled) showFormOnly();
                            }
                        }

                        setInitialLoading(false)
                    } else {
                        setInitialLoading(false)
                    }
                } 
                
            } catch (error) {
            }
        };

        const fetchIP = async () => {
            try {
                const response = await fetch('https://geolocation-db.com/json/');
                const data = await response.json();
                setIpAddress(data.IPv4);
            } catch (error) {
            }
        };
    
        fetchData();
        fetchIP();
    }, [client_id]);
    
    useEffect(() => {
        if(!isMultiOption){
            setStep(2)
        }
    },[isMultiOption])

    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    const getBorderRadiusClass = () => {
        if (style === "sharp") {
          return "rounded-none";
        } else if (style === "pill") {
          return "rounded-full";
        } else {
          return "rounded";
        }
    };

    const getBorderRadiusCardClass = () => {
        if (style === "sharp") {
          return "rounded-none";
        } else if (style === "pill") {
          return "rounded-[25px]";
        } else {
          return "rounded-[10px]";
        }
    };

    const handleCardNumberChange = (e : any) => {
        let input = e.target.value.replace(/\D/g, "");
        input = input.slice(0, 16);
        const formattedInput = input.replace(/(.{4})/g, "$1 ").trim();
        setPaymentData({ ...paymentData, cardNumber: formattedInput })
        if(formattedInput != "") {
            setOneErrors({ ...oneErrors, ['cardNumber']: '' });
        } else {
            setOneErrors({ ...oneErrors, ['cardNumber']: 'Field is required' });
        }
    };
    
    const handleExpiryDateChange = (e : any) => {
        let input = e.target.value.replace(/\D/g, "");
        input = input.slice(0, 4);
        if (input.length > 2) {
          input = `${input.slice(0, 2)} / ${input.slice(2)}`;
        }
        setPaymentData({ ...paymentData, expiry: input })
        if(input != "") {
            setOneErrors({ ...oneErrors, ['expiry']: '' });
        } else {
            setOneErrors({ ...oneErrors, ['expiry']: 'Field is required' });
        }
    };
    
    const handleCvvChange = (e : any) => {
        let input = e.target.value.replace(/\D/g, "");
        input = input.slice(0, 4);
        setPaymentData({ ...paymentData, cvv: input })
        if(input != "") {
            setOneErrors({ ...oneErrors, ['cvv']: '' });
        } else {
            setOneErrors({ ...oneErrors, ['cvv']: 'Field is required' });
        }
    };

    const handleCountryChange = (e : any) => {
        setPaymentData({ ...paymentData, country: e.target.value })
        if(e.target.value != "") {
            setOneErrors({ ...oneErrors, ['country']: '' });
        } else {
            setOneErrors({ ...oneErrors, ['country']: 'Field is required' });
        }
    };

    const handleCryptoCurrencyChangeNormal = (e:any) => {
        const networks = allBlockChainNetwork(e.target.value);
        setBlockChainNetworks(networks);
        setCryptoPaymentData({ ...cryptoPaymentData, crypto_currency: e.target.value , blockchain_network : "" })
        if(e.target.value != "") {
            setCryptoErrors({ ...cryptoErrors, ['crypto_currency']: '' });
        } else {
            setCryptoErrors({ ...cryptoErrors, ['crypto_currency']: 'Field is required' });
            setBlockChainNetworks([]);
        }
        setSelectedCryptoCurrency(e.target.options[e.target.selectedIndex].text)
        setSelectedCurrency(e.target.value)
    }

    const handleCryptoCurrencyChangeNormalPayout = (e:any) => {
        const networks = allBlockChainNetwork(e.target.value);
        setBlockChainNetworks(networks);
        setCryptoPayoutPaymentData({ ...cryptoPayoutPaymentData, crypto_currency: e.target.value , blockchain_network : "" })
        if(e.target.value != "") {
            setCryptoPayoutErrors({ ...cryptoErrors, ['crypto_currency']: '' });
        } else {
            setCryptoPayoutErrors({ ...cryptoErrors, ['crypto_currency']: 'Field is required' });
            setBlockChainNetworks([]);
        }
        setSelectedCryptoCurrency(e.target.options[e.target.selectedIndex].text)
        setSelectedCurrency(e.target.value)
    }

    const handleCryptoCurrencyChange = (e : any , type : any) => {
        let networks = []
        if(type == "api") { 
            networks = allBlockChainNetwork(e);
        } else {
            networks = allBlockChainNetwork(e.target.value);
        }
        setBlockChainNetworks(networks);
        
    };

    const handleBlockChainChange = (e : any) => {
        setCryptoPaymentData({ ...cryptoPaymentData, blockchain_network : e.target.value })
        if(e.target.value != "") {
            setCryptoErrors({ ...cryptoErrors, ['blockchain_network']: '' });
        } else {
            setCryptoErrors({ ...cryptoErrors, ['blockchain_network']: 'Field is required' });
        }
    };

    const handleBlockChainChangePayout = (e : any) => {
        setCryptoPayoutPaymentData({ ...cryptoPayoutPaymentData, blockchain_network : e.target.value })
        if(e.target.value != "") {
            setCryptoPayoutErrors({ ...cryptoErrors, ['blockchain_network']: '' });
        } else {
            setCryptoPayoutErrors({ ...cryptoErrors, ['blockchain_network']: 'Field is required' });
        }
    }; 

    const handleCryptoCountryChange = (e : any) => {
        setCryptoPaymentData({ ...cryptoPaymentData, country: e.target.value })
        if(e.target.value != "") {
            setCryptoErrors({ ...cryptoErrors, ['country']: '' });
        } else {
            setCryptoErrors({ ...cryptoErrors, ['country']: 'Field is required' });
        }
    };

    const handleCryptoPayoutCountryChange = (e : any) => {
        setCryptoPayoutPaymentData({ ...cryptoPayoutPaymentData, country: e.target.value })
        if(e.target.value != "") {
            setCryptoPayoutErrors({ ...cryptoPayoutErrors, ['country']: '' });
        } else {
            setCryptoPayoutErrors({ ...cryptoPayoutErrors, ['country']: 'Field is required' });
        }
    };

    const handleFiatPayoutCountryChange = (e : any) => {
        setFiatPayoutPaymentData({ ...fiatPayoutPaymentData, country: e.target.value })
        if(e.target.value != "") {
            setFiatPayoutErrors({ ...fiatPayoutErrors, ['country']: '' });
        } else {
            setFiatPayoutErrors({ ...fiatPayoutErrors, ['country']: 'Field is required' });
        }
    };

    const handleBackButton = () => {
        setAddressPreview(false);
        setIsLoading(false);
    }

    const getQRValue = () => {
        switch (cryptoPaymentData.crypto_currency) {
            case "Bitcoin":
            case "BTC":
                return `bitcoin:${cryptoAddress}?amount=${cryptoAmount}`;
            case "Ethereum":
            case "ETH":
                return `ethereum:${cryptoAddress}?value=${cryptoAmount}`;
            case "USDT":
                return `ethereum:${cryptoAddress}?contract=1234567890&value=${cryptoAmount}`;
            default:
                return cryptoAddress;
        }
    };

    const handlePayNow   = async() => {
        setIsLoading(true);
        
        if(paymentType == 'one-time-payment') {
            if (!validateOneTimeFields()) {
                setIsLoading(false);
                return;
            }
            setPaymentStatus('processing');
            const [month, year] = paymentData.expiry.split(" / ").map((part) => part.trim());
            const payload = {
                "payment_type": 'ONE_TIME',
                "checkout_details": {
                    "id": checkout_id,
                    "expires_at": expiresAt,
                    "client_id": client_id
                },
                "payment_request_data": {
                    "internal_tx_id" : internal_tx_id,
                    "first_name": paymentData.first_name,
                    "middle_name": paymentData.middle_name,
                    "last_name": paymentData.last_name,
                    "email": paymentData.email,
                    "phone": paymentData.phone,
                    "city": paymentData.city,
                    "address": paymentData.address,
                    "postal_code": paymentData.postalCode,
                    "state": paymentData.state,
                    "country": paymentData.country,
                    "ip": ipAddress,
                    "cardholder_name": paymentData.cardHolderName,
                    "card_number": paymentData.cardNumber.replace(/\s+/g, ''),
                    "expiration_month": month,
                    "expiration_year": year,
                    "cvv": paymentData.cvv,
                    "amount": parseFloat(amount).toFixed(2),
                    "currency": selectedCurrency,
                    ...(return_url && return_url.trim() !== "" && { return_url }),
                    ...(callback_url && callback_url.trim() !== "" && { callback_url })
                }
            }
            createPayment(payload,client_id,checkout_id,unique_payment_link_id,client_secret)
            .then((response) => {
                setIsProcess(false);
                if(response.status == false) {
                    setIsLoading(false);
                    setPaymentStatus('failed');
                    setPaymentError( "Something went wrong please contact admin");
                } else {
                    const { initiated, message } = response.data.payment_response;
                    const isObject = (value : any) => value && typeof value === 'object' && !Array.isArray(value);
                    let isError;
                    if (initiated) {
                        isError = !isObject(message);
                    } else {
                        isError = !isObject(message);
                    }
                    if(isError) {
                        setIsLoading(false);
                        setPaymentStatus('failed');
                        setPaymentError( "Something went wrong please contact admin");
                    } else {
                        setIsLoading(false);
                        setTargetDateTime(null);
                        const paymentData = response?.data?.payment_response
                        const status = paymentData?.message?.status;
                        if(status == 'DECLINED' || status == 'CANCELLED' || status == 'REJECTED' || status == 'ERRORED') {
                            setPaymentStatus(status.toLower());
                            if (return_url) {
                                setTimeout(() => {
                                    window.location.href = return_url;
                                }, 2000);
                            }
                        } else if(status == 'APPROVED') {
                            setPaymentStatus('approved');
                            if (return_url) {
                                setTimeout(() => {
                                    window.location.href = return_url;
                                }, 2000);
                            }
                        } else if(status == 'PENDING') {
                            setPaymentStatus('pending');
                            const redirectUri = response?.data?.redirect_uri;
                            if (redirectUri) {
                                setTimeout(() => {
                                    window.location.href = redirectUri;
                                }, 2000);
                            }
                        }
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setPaymentStatus('failed');
                setPaymentError( "Something went wrong please contact admin");
            });

        } else if(paymentType == 'pix-payment') {
            if (!validatePixFields()) {
                setIsLoading(false);
                return;
            }
            setPaymentStatus('processing');
            const payload = {
                "payment_type": 'PIX',
                "internal_tx_id" : internal_tx_id,
                "checkout_details": {
                    "id": checkout_id,
                    "expires_at": expiresAt,
                    "client_id": client_id
                },
                "payment_request_data": {
                    "sender_details" : {
                        "first_name": pixPaymentData.first_name,
                        "last_name": pixPaymentData.last_name,
                        "identification_number": pixPaymentData.identification_number,
                        "identification_type": pixPaymentData.identification_type,
                    },
                    "payin_information" : {
                        "amount": parseFloat(amount).toFixed(2),
                        "currency": selectedCurrency,
                        ...(return_url && return_url.trim() !== "" && { return_url }),
                        ...(callback_url && callback_url.trim() !== "" && { callback_url })
                    }
                }
            }
            createPayment(payload,client_id,checkout_id,unique_payment_link_id,client_secret)
            .then((response) => {
                setIsProcess(false);
                
                if(response.status == false) {
                    setIsLoading(false);
                    setPaymentStatus('failed');
                    setPaymentError( "Something went wrong please contact admin");
                } else {
                    const { initiated, message } = response.data.payment_response;

                    const isObject = (value : any) => value && typeof value === 'object' && !Array.isArray(value);

                    let isError;
                    if (initiated) {
                        isError = !isObject(message);
                    } else {
                        isError = !isObject(message);
                    }
                    if(isError) {
                        setIsLoading(false);
                        setPaymentStatus('failed');
                        setPaymentError( "Something went wrong please contact admin");
                    } else {
                        setIsLoading(false);
                        setTargetDateTime(null);
                        const paymentData = response?.data?.payment_response
                        const status = paymentData?.message?.status;
                        if(status == 'DECLINED' || status == 'CANCELLED' || status == 'REJECTED' || status == 'ERRORED') {
                            setPaymentStatus(status.toLower());
                            if (return_url) {
                                setTimeout(() => {
                                    window.location.href = return_url;
                                }, 2000);
                            }
                        } else if(status == 'APPROVED') {
                            setPaymentStatus('approved');
                            if (return_url) {
                                setTimeout(() => {
                                    window.location.href = return_url;
                                }, 2000);
                            }
                        } else if(status == 'PENDING') {
                            setPaymentStatus('pending');
                            const redirectUri = response?.data?.redirect_uri;
                            if (redirectUri) {
                                setTimeout(() => {
                                    window.location.href = redirectUri;
                                }, 2000);
                            }
                        }
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setPaymentStatus('failed');
                setPaymentError( "Something went wrong please contact admin");
            });
        } else if(paymentType == 'crypto') {
            if (!validateCryptoFields()) {
                setIsLoading(false);
                return;
            }
            setPaymentStatus('processing');
            const payload = {
                "client_id" : client_id,
                "checkout_id" : checkout_id,
                "unique_payment_link_id" : unique_payment_link_id,
                "network" : cryptoPaymentData?.blockchain_network,
                "currency" : cryptoPaymentData?.crypto_currency,
                "first_name" : cryptoPaymentData?.first_name,
                "last_name" : cryptoPaymentData?.last_name,
                "email" : cryptoPaymentData?.email,
                "phone" : cryptoPaymentData?.phone,
                "country" : cryptoPaymentData?.country,
                "amount" : amount
            }

            const wallet_details = await getWalletDetails(payload);
            if(wallet_details.status) {
                setPaymentStatus('idle');
                setCryptoAddress(wallet_details.data.address);
                const qrValue = getQRValue() 
                setQrCode(qrValue)
                setIsLoading(false);
                setAddressPreview(true);
                localStorage.setItem(unique_payment_link_id,'yes');
            } else {
                setPaymentStatus('idle');
                setIsLoading(false);
                toast.error(wallet_details.data.message)
            }
        } else if(paymentType == 'crypto-payout') {
            if (!validateCryptoPayoutFields()) {
                setIsLoading(false);
                return;
            }
            setPaymentStatus('processing');
            const c_id =  client_id;
            const c_secret =  client_secret;
            const payload = {
                "checkout_id" : checkout_id,
                "unique_payment_link_id" : unique_payment_link_id,
                "customer_information" :  {
                    "first_name" : cryptoPayoutPaymentData?.first_name,
                    "last_name" : cryptoPayoutPaymentData?.last_name,
                    "email" : cryptoPayoutPaymentData?.email,
                    "phone" : cryptoPayoutPaymentData?.phone,
                    "country" : cryptoPayoutPaymentData?.country,
                    "city" : cryptoPayoutPaymentData?.city,
                    "address" : cryptoPayoutPaymentData?.address,
                    "state" : cryptoPayoutPaymentData?.state,
                    "postal_code" : cryptoPayoutPaymentData?.postal_code
                },
                "payout_information" :  {
                    "amount" : amount,
                    "currency" : cryptoPayoutPaymentData?.crypto_currency,
                    "chain" : cryptoPayoutPaymentData?.blockchain_network,
                    "address" : cryptoPayoutPaymentData?.wallet_address,
                }
            }
            const wallet_details = await getCryptoPayout(c_id,c_secret,payload);
            const status = wallet_details[0].message?.status
            if(status == "PENDING") {
                setPaymentStatus('pending');
                setIsLoading(false);
                if (return_url) {
                    setTimeout(() => {
                        window.location.href = return_url;
                    }, 2000);
                }
            } else if(status == "APPROVED") {
                setPaymentStatus('approved');
                setIsLoading(false);
                if (return_url) {
                    setTimeout(() => {
                        window.location.href = return_url;
                    }, 2000);
                }
            } else if(status == "DECLINED") {
                setPaymentError( "Something went wrong please contact admin");
                setPaymentStatus('declined');
                setIsLoading(false);
                if (return_url) {
                    setTimeout(() => {
                        window.location.href = return_url;
                    }, 2000);
                }
            } else if(status == "ERRORED") {
                setPaymentError( "Something went wrong please contact admin");
                setPaymentStatus('errored');
                setIsLoading(false);
                if (return_url) {
                    setTimeout(() => {
                        window.location.href = return_url;
                    }, 2000);
                }
            } else {
                setIsLoading(false);
                setPaymentError( "Something went wrong please contact admin");
                setPaymentStatus('failed');
                if (return_url) {
                    setTimeout(() => {
                        window.location.href = return_url;
                    }, 2000);
                }
            }
        } else if(paymentType == 'fiat-payout') {
            if (!validateFiatPayoutFields()) {
                setIsLoading(false);
                return;
            }
            setPaymentStatus('processing');
            const c_id =  client_id;
            const c_secret =  client_secret;
            const payload = {
                "checkout_id" : checkout_id,
                "unique_payment_link_id" : unique_payment_link_id,
                "customer_information" :  {
                    "first_name" : fiatPayoutPaymentData?.first_name,
                    "last_name" : fiatPayoutPaymentData?.last_name,
                    "email" : fiatPayoutPaymentData?.email,
                    "phone" : fiatPayoutPaymentData?.phone,
                    "country" : fiatPayoutPaymentData?.country,
                    "city" : fiatPayoutPaymentData?.city,
                    "address" : fiatPayoutPaymentData?.address,
                    "state" : fiatPayoutPaymentData?.state,
                    "postal_code" : fiatPayoutPaymentData?.postal_code
                },
                "customer_payment_information" :  {
                    "document_number" : fiatPayoutPaymentData?.document_number,
                    "bank_account" : fiatPayoutPaymentData?.bank_account,
                    "bank_code" : fiatPayoutPaymentData?.bank_code,
                    "account_type" : fiatPayoutPaymentData?.account_type,
                    "country_code" : fiatPayoutPaymentData?.country,
                },
                "payout_information" :  {
                    "amount" : amount,
                    "currency" : fiatPayoutPaymentData?.currency,
                    "fiat_currency" : fiatPayoutPaymentData?.fiat_currency,
                    "blockchain_symbol" : fiatPayoutPaymentData?.blockchain_symbol,
                    "token_symbol" : fiatPayoutPaymentData?.token_symbol,
                }
            }
            const wallet_details = await getFiatPayout(c_id,c_secret,payload);
            const status = wallet_details[0].message?.status
            if(status == "PENDING") {
                setPaymentStatus('pending');
                setIsLoading(false);
                if (return_url) {
                    setTimeout(() => {
                        window.location.href = return_url;
                    }, 2000);
                }
            } else if(status == "APPROVED") {
                setPaymentStatus('approved');
                setIsLoading(false);
                if (return_url) {
                    setTimeout(() => {
                        window.location.href = return_url;
                    }, 2000);
                }
            } else if(status == "DECLINED") {
                setPaymentError( "Something went wrong please contact admin");
                setPaymentStatus('declined');
                setIsLoading(false);
                if (return_url) {
                    setTimeout(() => {
                        window.location.href = return_url;
                    }, 2000);
                }
            } else if(status == "ERRORED") {
                setPaymentError( "Something went wrong please contact admin");
                setPaymentStatus('errored');
                setIsLoading(false);
                if (return_url) {
                    setTimeout(() => {
                        window.location.href = return_url;
                    }, 2000);
                }
            } else {
                setIsLoading(false);
                setPaymentError( "Something went wrong please contact admin");
                setPaymentStatus('failed');
                if (return_url) {
                    setTimeout(() => {
                        window.location.href = return_url;
                    }, 2000);
                }
            }
        }
    } 

    const handleNext = () => {
        if(paymentType == "" || paymentType == null || paymentType == undefined) {
            toast.error("Please select any payment type to process further")
        }
        // setShowForm(true);
        setTimeout(() => setStep(2), 300);
    }

    const handleGoBack = () => {
        setShowForm(false);
    }

    const handleClose = () => {
        onClose();
      };

    const generateNewLink = () => {
        setIsLoading(true);
        const payload = {
            "client_id" : client_id,
            "checkout_id": checkout_id,
            "unique_payment_link_id" : unique_payment_link_id
        }
        generateCheckoutLink(payload,client_id,client_secret)
        .then((response) => {
            // let updatedUrl = '';

            // if (window.location.hostname === "gateway-dev.lightningchecks.com") {
            //     const newBaseUrl = "https://gateway-dev.lightningchecks.com/";
            //     updatedUrl  = response?.data?.payment_link.replace(
            //     "https://backend-dev.bm2pay.com/api/v1/",
            //     newBaseUrl
            //     );
            // } else if (window.location.hostname === "gateway.lightningchecks.com") {
            //     const newBaseUrl = "https://gateway.lightningchecks.com/";
            //     updatedUrl  = response?.data?.payment_link.replace(
            //     "https://backend.lightningchecks.com/api/v1/",
            //     newBaseUrl
            //     );
            // } else if (window.location.hostname === "gateway-dev.bm2pay.com") {
            //     const newBaseUrl = "https://gateway-dev.bm2pay.com/";
            //     updatedUrl  = response?.data?.payment_link.replace(
            //     "https://backend-dev.bm2pay.com/api/v1/",
            //     newBaseUrl
            //     );
            // } else if (window.location.hostname === "gateway.bm2pay.com") {
            //     const newBaseUrl = "https://gateway.bm2pay.com/";
            //     updatedUrl  = response?.data?.payment_link.replace(
            //     "https://backend.bm2pay.com/api/v1/",
            //     newBaseUrl
            //     );
            // } else if (window.location.hostname === "pay.paxum.com") {
            //     const newBaseUrl = "https://pay.paxum.com/";
            //     updatedUrl  = response?.data?.payment_link.replace(
            //     "https://backend.paxum.com/api/v1/",
            //     newBaseUrl
            //     );
            // } else {
            //     // const newBaseUrl = "https://gateway-dev.bm2pay.com/";
            //     const newBaseUrl = "http://localhost:3000/";
            //     updatedUrl  = response?.data?.payment_link.replace(
            //     "https://backend-dev.bm2pay.com/api/v1/",
            //     newBaseUrl
            //     );
            // }

            // if (updatedUrl) {
                handleClose();
                setIsLoading(false);
                toast.success(response?.message)
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
               localStorage.setItem(unique_payment_link_id,'yes');
            // }
        })
        .catch((error) => {
        });
    }

    const hanldleCurrenyChange = (e:any) => {
        const value = e
        setSelectedCurrency(value);
    }

    if (initialLoading) {
        return (
            <div className="mt-5 pt-5">
                <DivLoader className="m-5 h-6 w-6 border-indigo-500" />
                <p className="text-center" style={{fontFamily: selectedFont}}>Loading, please wait...</p>
            </div>
        )
        // return (
        //   <div 
        //     className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden"
        //     style={{ 
        //         background: `linear-gradient(to right, ${primaryColor}, ${secondaryColor})` 
        //     }}
        // >
        //     <div className="absolute inset-0 overflow-hidden">
        //       <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-teal-500/30 rounded-full blur-3xl animate-pulse" />
        //       <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-500/30 rounded-full blur-3xl animate-pulse" style={{animationDelay:'1s'}} />
        //       <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl animate-pulse" style={{animationDelay:'2s'}} />
        //     </div>
        //     <div className="text-center relative z-10">
        //       <div className="relative w-32 h-32 mx-auto mb-6">
        //         <AiOutlineLoading3Quarters className="text-7xl text-teal-400 animate-spin mx-auto" />
        //         <div className="absolute inset-0 bg-teal-400/20 rounded-full blur-2xl animate-pulse" />
        //       </div>
        //       <h2 className="text-2xl font-bold text-white mb-2 animate-fadeIn">Preparing Checkout...</h2>
        //       <p className="text-gray-400 animate-fadeIn" style={{animationDelay:'0.2s'}}>Please wait while we load your payment details</p>
        //     </div>
        //   </div>
        // );
    }

    if (isUsed) {
        return (
          <div 
            className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden"
            style={{ 
                background: `linear-gradient(to right, ${primaryColor}, ${secondaryColor})` 
            }}
          >
            <div className="absolute inset-0 overflow-hidden">
              <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-orange-500/20 rounded-full blur-3xl animate-pulse" />
              <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-yellow-500/20 rounded-full blur-3xl animate-pulse" style={{animationDelay:'1s'}} />
            </div>
            <div className="relative bg-gray-900/80 backdrop-blur-2xl rounded-3xl p-12 max-w-md w-full shadow-2xl border border-orange-500/30 animate-slideUp">
              <div className="text-center">
                <div className="mx-auto w-28 h-28 rounded-full flex items-center justify-center mb-8 bg-orange-500/30 animate-scaleIn">
                  <div className="w-20 h-20 rounded-full flex items-center justify-center bg-orange-500 animate-pulse">
                    <AiOutlineCheck className="text-5xl text-white" />
                  </div>
                </div>
                <h2 className="text-4xl font-bold mb-4 text-orange-400 animate-fadeIn" style={{animationDelay:'0.2s',fontFamily: selectedFont}}>
                  Link Already Used!
                </h2>
                <p className="text-gray-400 mb-4 text-lg animate-fadeIn" style={{animationDelay:'0.4s',fontFamily: selectedFont}}>
                  This payment link has already been used for a transaction.
                </p>
                <p className="text-gray-500 text-sm animate-fadeIn" style={{animationDelay:'0.6s',fontFamily: selectedFont}}>
                  Each payment link can only be used once. Please request a new payment link from the merchant.
                </p>
              </div>
            </div>
          </div>
        );
    }

    if (isExpired && !paymentCompeleted) {
        return (
          <div 
            className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden"
            style={{ 
                background: `linear-gradient(to right, ${primaryColor}, ${secondaryColor})` 
            }}
        >
            <div className="absolute inset-0 overflow-hidden">
              <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-red-500/20 rounded-full blur-3xl animate-pulse" />
              <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-orange-500/20 rounded-full blur-3xl animate-pulse" style={{animationDelay:'1s'}} />
            </div>
            <div className="relative bg-gray-900/80 backdrop-blur-2xl rounded-3xl p-12 max-w-md w-full shadow-2xl border border-red-500/30 animate-slideUp">
              <div className="text-center">
                <div className="mx-auto w-28 h-28 rounded-full flex items-center justify-center mb-8 bg-red-500/30 animate-scaleIn">
                  <div className="w-20 h-20 rounded-full flex items-center justify-center bg-red-500 animate-pulse">
                    <AiOutlineClose className="text-5xl text-white" />
                  </div>
                </div>
                <h2 className="text-4xl font-bold mb-4 text-red-400 animate-fadeIn" style={{animationDelay:'0.2s',fontFamily: selectedFont}}>
                  Link Expired!
                </h2>
                {localStorage.getItem(unique_payment_link_id) == 'no' && !addressPreview ? (
                    <>
                        <p className="text-gray-400 mb-4 text-lg animate-fadeIn" style={{animationDelay:'0.4s',fontFamily: selectedFont}}>
                            Would you like to extend its validity?
                        </p>
                        <p className="text-gray-500 text-sm animate-fadeIn" style={{animationDelay:'0.6s',fontFamily: selectedFont}}>
                            If yes, simply click the Extend Expiry button below.The link will extend for 5 min.
                        </p>

                        <button onClick={generateNewLink} className="w-full text-white py-4 mt-4 rounded-2xl font-bold text-lg hover:shadow-2xl  transition-all duration-300 hover:scale-105 animate-fadeIn" style={{animationDelay:'0.6s' , backgroundColor : buttonColor, fontFamily : selectedFont}}>
                        {isLoading ? (
                            <DivLoader className="h-6 w-6 border-red-400" />
                        ) : (
                            "Extend Link"
                        )}
                        </button>
                    </>
                ) : (
                    <>
                        <p className="text-gray-400 mb-4 text-lg animate-fadeIn" style={{animationDelay:'0.4s',fontFamily: selectedFont}}>
                        This payment link has expired and is no longer valid.
                        </p>
                        <p className="text-gray-500 text-sm animate-fadeIn" style={{animationDelay:'0.6s',fontFamily: selectedFont}}>
                        Please contact the merchant to receive a new payment link.
                        </p>
                    </>
                )}
              </div>
            </div>
          </div>
        );
    }

    if (paymentStatus === 'processing') {
        return (
          <div 
            className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden"
            style={{ 
                background: `linear-gradient(to right, ${primaryColor}, ${secondaryColor})` 
            }}
        >
            <div className="absolute inset-0 overflow-hidden">
              <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-teal-500/30 rounded-full blur-3xl animate-pulse" />
              <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-500/30 rounded-full blur-3xl animate-pulse" style={{animationDelay:'1s'}} />
            </div>
            <div className="text-center relative z-10">
              <div className="relative w-40 h-40 mx-auto mb-8">
                <div className="absolute inset-0 border-4 border-transparent border-t-teal-400 border-r-teal-400 rounded-full animate-spin" />
                <div className="absolute inset-3 border-4 border-transparent border-b-purple-400 border-l-purple-400 rounded-full animate-spin-reverse" />
                <div className="absolute inset-6 bg-gradient-to-br from-teal-400 to-purple-500 rounded-full animate-pulse flex items-center justify-center">
                  <AiOutlineCreditCard className="text-4xl text-white animate-bounce-slow" />
                </div>
                <div className="absolute inset-0 bg-teal-400/20 rounded-full blur-2xl animate-pulse" />
                <div className="absolute top-0 left-1/2 w-3 h-3 bg-teal-400 rounded-full animate-orbit" style={{transformOrigin: '0 80px'}} />
                <div className="absolute top-0 left-1/2 w-3 h-3 bg-purple-400 rounded-full animate-orbit" style={{transformOrigin: '0 80px', animationDelay: '0.5s'}} />
              </div>
              <h2 className="text-3xl font-bold text-white mb-3 animate-fadeIn" style={{fontFamily: selectedFont}}>Processing Payment...</h2>
              <p className="text-white text-lg mb-4 animate-fadeIn" style={{animationDelay:'0.2s',fontFamily: selectedFont}}>Please wait while we securely process your transaction</p>
              <div className="flex items-center justify-center gap-2 animate-fadeIn" style={{animationDelay:'0.4s'}}>
                <div className="w-2 h-2 bg-teal-400 rounded-full animate-pulse" />
                <div className="w-2 h-2 bg-teal-400 rounded-full animate-pulse" style={{animationDelay:'0.2s'}} />
                <div className="w-2 h-2 bg-teal-400 rounded-full animate-pulse" style={{animationDelay:'0.4s'}} />
              </div>
            </div>
          </div>
        );
    }

    if (paymentStatus === 'approved') {
        return (
            <div 
                className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden"
                style={{ 
                    background: `linear-gradient(to right, ${primaryColor}, ${secondaryColor})` 
                }}
            >
                <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-teal-500/30 rounded-full blur-3xl animate-pulse" />
                    <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-500/30 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
                </div>
                <div className="relative bg-gray-900/60 backdrop-blur-2xl rounded-3xl p-12 max-w-md w-full shadow-2xl border border-white/10 animate-slideUp">
                    <div className="text-center">
                        <div className="mx-auto w-28 h-28 rounded-full flex items-center justify-center mb-8 bg-teal-500/30 animate-scaleIn">
                            <div className="w-20 h-20 rounded-full flex items-center justify-center bg-teal-500 animate-ping-once">
                                <AiOutlineCheck className="text-5xl text-white animate-checkmark" />
                            </div>
                        </div>
                        <h2 className="text-4xl font-bold mb-4 text-teal-400 animate-fadeIn" style={{ animationDelay: '0.2s',fontFamily: selectedFont }}>
                            Payment Successful!
                        </h2>
                        <p className="text-gray-400 mb-8 text-lg animate-fadeIn" style={{ animationDelay: '0.4s',fontFamily: selectedFont }}>
                            Your transaction has been completed successfully.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    if (paymentStatus === 'pending') {
        return (
            <div 
                className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden"
                style={{ 
                    background: `linear-gradient(to right, ${primaryColor}, ${secondaryColor})` 
                }}
            >
                <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-teal-500/30 rounded-full blur-3xl animate-pulse" />
                    <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-500/30 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
                </div>
                <div className="relative bg-gray-900/60 backdrop-blur-2xl rounded-3xl p-12 max-w-md w-full shadow-2xl border border-white/10 animate-slideUp">
                    <div className="text-center">
                        <div className="mx-auto w-28 h-28 rounded-full flex items-center justify-center mb-8 bg-teal-500/30 animate-scaleIn">
                            <div className="w-20 h-20 rounded-full flex items-center justify-center bg-teal-500 animate-ping-once">
                                <AiFillExclamationCircle className="text-5xl text-white animate-checkmark" />
                            </div>
                        </div>
                        <h2 className="text-4xl font-bold mb-4 text-teal-400 animate-fadeIn" style={{ animationDelay: '0.2s',fontFamily: selectedFont }}>
                            Payment Pending!
                        </h2>
                        <p className="text-gray-400 mb-8 text-lg animate-fadeIn" style={{ animationDelay: '0.4s',fontFamily: selectedFont }}>
                            Your transaction has been pending.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    if (paymentStatus === 'failed') {
        return (
            <div 
                className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden"
                style={{ 
                    background: `linear-gradient(to right, ${primaryColor}, ${secondaryColor})` 
                }}
            >
                <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-red-500/30 rounded-full blur-3xl animate-pulse" />
                    <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-orange-500/30 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
                </div>
                <div className="relative bg-gray-900/60 backdrop-blur-2xl rounded-3xl p-12 max-w-md w-full shadow-2xl border border-white/10 animate-slideUp">
                    <div className="text-center">
                        <div className="mx-auto w-28 h-28 rounded-full flex items-center justify-center mb-8 bg-red-500/30 animate-shake">
                            <div className="w-20 h-20 rounded-full flex items-center justify-center bg-red-500 animate-shake">
                                <AiOutlineClose className="text-5xl text-white" />
                            </div>
                        </div>
                        <h2 className="text-4xl font-bold mb-4 text-red-400 animate-fadeIn" style={{ animationDelay: '0.2s',fontFamily: selectedFont }}>
                            Payment Failed
                        </h2>
                        {paymentError != "" ? (
                            <p className="text-gray-300 mb-8 text-lg animate-fadeIn" style={{ animationDelay: '0.4s',fontFamily: selectedFont }}>
                                {paymentError}
                            </p>
                        ) : (
                            <p className="text-gray-300 mb-8 text-lg animate-fadeIn" style={{ animationDelay: '0.4s',fontFamily: selectedFont }}>
                                Something went wrong with your payment. Please try again or contact support.
                            </p>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    if (paymentStatus === 'rejected') {
        return (
            <div 
                className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden"
                style={{ 
                    background: `linear-gradient(to right, ${primaryColor}, ${secondaryColor})` 
                }}
            >
                <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-red-500/30 rounded-full blur-3xl animate-pulse" />
                    <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-orange-500/30 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
                </div>
                <div className="relative bg-gray-900/60 backdrop-blur-2xl rounded-3xl p-12 max-w-md w-full shadow-2xl border border-white/10 animate-slideUp">
                    <div className="text-center">
                        <div className="mx-auto w-28 h-28 rounded-full flex items-center justify-center mb-8 bg-red-500/30 animate-shake">
                            <div className="w-20 h-20 rounded-full flex items-center justify-center bg-red-500 animate-shake">
                                <AiOutlineClose className="text-5xl text-white" />
                            </div>
                        </div>
                        <h2 className="text-4xl font-bold mb-4 text-red-400 animate-fadeIn" style={{ animationDelay: '0.2s',fontFamily: selectedFont }}>
                            Payment Rejected
                        </h2>
                        {paymentError != "" ? (
                            <p className="text-gray-300 mb-8 text-lg animate-fadeIn" style={{ animationDelay: '0.4s',fontFamily: selectedFont }}>
                                {paymentError}
                            </p>
                        ) : (
                            <p className="text-gray-300 mb-8 text-lg animate-fadeIn" style={{ animationDelay: '0.4s',fontFamily: selectedFont }}>
                                Something went wrong with your payment. Please try again or contact support.
                            </p>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    if (paymentStatus === 'declined') {
        return (
            <div 
                className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden"
                style={{ 
                    background: `linear-gradient(to right, ${primaryColor}, ${secondaryColor})` 
                }}
            >
                <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-red-500/30 rounded-full blur-3xl animate-pulse" />
                    <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-orange-500/30 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
                </div>
                <div className="relative bg-gray-900/60 backdrop-blur-2xl rounded-3xl p-12 max-w-md w-full shadow-2xl border border-white/10 animate-slideUp">
                    <div className="text-center">
                        <div className="mx-auto w-28 h-28 rounded-full flex items-center justify-center mb-8 bg-red-500/30 animate-shake">
                            <div className="w-20 h-20 rounded-full flex items-center justify-center bg-red-500 animate-shake">
                                <AiOutlineClose className="text-5xl text-white" />
                            </div>
                        </div>
                        <h2 className="text-4xl font-bold mb-4 text-red-400 animate-fadeIn" style={{ animationDelay: '0.2s',fontFamily: selectedFont }}>
                            Payment Declined
                        </h2>
                        {paymentError != "" ? (
                            <p className="text-gray-300 mb-8 text-lg animate-fadeIn" style={{ animationDelay: '0.4s',fontFamily: selectedFont }}>
                                {paymentError}
                            </p>
                        ) : (
                            <p className="text-gray-300 mb-8 text-lg animate-fadeIn" style={{ animationDelay: '0.4s',fontFamily: selectedFont }}>
                                Something went wrong with your payment. Please try again or contact support.
                            </p>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    if (paymentStatus === 'errored') {
        return (
            <div 
                className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden"
                style={{ 
                    background: `linear-gradient(to right, ${primaryColor}, ${secondaryColor})` 
                }}
            >
                <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-red-500/30 rounded-full blur-3xl animate-pulse" />
                    <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-orange-500/30 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
                </div>
                <div className="relative bg-gray-900/60 backdrop-blur-2xl rounded-3xl p-12 max-w-md w-full shadow-2xl border border-white/10 animate-slideUp">
                    <div className="text-center">
                        <div className="mx-auto w-28 h-28 rounded-full flex items-center justify-center mb-8 bg-red-500/30 animate-shake">
                            <div className="w-20 h-20 rounded-full flex items-center justify-center bg-red-500 animate-shake">
                                <AiOutlineClose className="text-5xl text-white" />
                            </div>
                        </div>
                        <h2 className="text-4xl font-bold mb-4 text-red-400 animate-fadeIn" style={{ animationDelay: '0.2s',fontFamily: selectedFont }}>
                            Payment Errored
                        </h2>
                        {paymentError != "" ? (
                            <p className="text-gray-300 mb-8 text-lg animate-fadeIn" style={{ animationDelay: '0.4s',fontFamily: selectedFont }}>
                                {paymentError}
                            </p>
                        ) : (
                            <p className="text-gray-300 mb-8 text-lg animate-fadeIn" style={{ animationDelay: '0.4s',fontFamily: selectedFont }}>
                                Something went wrong with your payment. Please try again or contact support.
                            </p>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    if (paymentStatus === 'cancelled') {
        return (
            <div 
                className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden"
                style={{ 
                    background: `linear-gradient(to right, ${primaryColor}, ${secondaryColor})` 
                }}
            >
                <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-red-500/30 rounded-full blur-3xl animate-pulse" />
                    <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-orange-500/30 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
                </div>
                <div className="relative bg-gray-900/60 backdrop-blur-2xl rounded-3xl p-12 max-w-md w-full shadow-2xl border border-white/10 animate-slideUp">
                    <div className="text-center">
                        <div className="mx-auto w-28 h-28 rounded-full flex items-center justify-center mb-8 bg-red-500/30 animate-shake">
                            <div className="w-20 h-20 rounded-full flex items-center justify-center bg-red-500 animate-shake">
                                <AiOutlineClose className="text-5xl text-white" />
                            </div>
                        </div>
                        <h2 className="text-4xl font-bold mb-4 text-red-400 animate-fadeIn" style={{ animationDelay: '0.2s',fontFamily: selectedFont }}>
                            Payment Cancelled
                        </h2>
                        {paymentError != "" ? (
                            <p className="text-gray-300 mb-8 text-lg animate-fadeIn" style={{ animationDelay: '0.4s',fontFamily: selectedFont }}>
                                {paymentError}
                            </p>
                        ) : (
                            <p className="text-gray-300 mb-8 text-lg animate-fadeIn" style={{ animationDelay: '0.4s',fontFamily: selectedFont }}>
                                Something went wrong with your payment. Please try again or contact support.
                            </p>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    if(paymentType !== 'one-time-payment' && allPaymentDisabled) {
        return (
            <div 
                className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden"
                style={{ 
                    background: `linear-gradient(to right, ${primaryColor}, ${secondaryColor})` 
                }}
            >
                <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-red-500/30 rounded-full blur-3xl animate-pulse" />
                    <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-orange-500/30 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
                </div>
                <div className="relative bg-gray-900/60 backdrop-blur-2xl rounded-3xl p-12 max-w-md w-full shadow-2xl border border-white/10 animate-slideUp">
                    <div className="text-center">
                        <div className="mx-auto w-28 h-28 rounded-full flex items-center justify-center mb-8 bg-red-500/30 animate-shake">
                            <div className="w-20 h-20 rounded-full flex items-center justify-center bg-red-500 animate-shake">
                                <AiOutlineClose className="text-5xl text-white" />
                            </div>
                        </div>
                        <h2 className="text-4xl font-bold mb-4 text-red-400 animate-fadeIn" style={{ animationDelay: '0.2s',fontFamily: selectedFont }}>
                            Oops !!
                        </h2>
                        <p className="text-gray-300 mb-8 text-lg animate-fadeIn" style={{ animationDelay: '0.4s',fontFamily: selectedFont }}>
                            It looks like no payment methods have been enabled yet.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    if(paymentType === "pix-payment" &&  disabledMethods?.payin) {
        return (
            <div 
                className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden"
                style={{ 
                    background: `linear-gradient(to right, ${primaryColor}, ${secondaryColor})` 
                }}
            >
                <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-red-500/30 rounded-full blur-3xl animate-pulse" />
                    <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-orange-500/30 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
                </div>
                <div className="relative bg-gray-900/60 backdrop-blur-2xl rounded-3xl p-12 max-w-md w-full shadow-2xl border border-white/10 animate-slideUp">
                    <div className="text-center">
                        <div className="mx-auto w-28 h-28 rounded-full flex items-center justify-center mb-8 bg-red-500/30 animate-shake">
                            <div className="w-20 h-20 rounded-full flex items-center justify-center bg-red-500 animate-shake">
                                <AiOutlineClose className="text-5xl text-white" />
                            </div>
                        </div>
                        <h2 className="text-4xl font-bold mb-4 text-red-400 animate-fadeIn" style={{ animationDelay: '0.2s',fontFamily: selectedFont }}>
                            Oops !!
                        </h2>
                        <p className="text-gray-300 mb-8 text-lg animate-fadeIn" style={{ animationDelay: '0.4s',fontFamily: selectedFont }}>
                            It looks like no PIX payment methods have been enabled yet.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    if(paymentType === "crypto" &&  disabledMethods?.cryptoPayin) {
        return (
            <div 
                className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden"
                style={{ 
                    background: `linear-gradient(to right, ${primaryColor}, ${secondaryColor})` 
                }}
            >
                <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-red-500/30 rounded-full blur-3xl animate-pulse" />
                    <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-orange-500/30 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
                </div>
                <div className="relative bg-gray-900/60 backdrop-blur-2xl rounded-3xl p-12 max-w-md w-full shadow-2xl border border-white/10 animate-slideUp">
                    <div className="text-center">
                        <div className="mx-auto w-28 h-28 rounded-full flex items-center justify-center mb-8 bg-red-500/30 animate-shake">
                            <div className="w-20 h-20 rounded-full flex items-center justify-center bg-red-500 animate-shake">
                                <AiOutlineClose className="text-5xl text-white" />
                            </div>
                        </div>
                        <h2 className="text-4xl font-bold mb-4 text-red-400 animate-fadeIn" style={{ animationDelay: '0.2s',fontFamily: selectedFont }}>
                            Oops !!
                        </h2>
                        <p className="text-gray-300 mb-8 text-lg animate-fadeIn" style={{ animationDelay: '0.4s',fontFamily: selectedFont }}>
                            It looks like Crypto payment methods have been enabled yet.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    if(paymentType === "crypto-payout" &&  disabledMethods?.cryptoPayout) {
        return (
            <div 
                className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden"
                style={{ 
                    background: `linear-gradient(to right, ${primaryColor}, ${secondaryColor})` 
                }}
            >
                <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-red-500/30 rounded-full blur-3xl animate-pulse" />
                    <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-orange-500/30 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
                </div>
                <div className="relative bg-gray-900/60 backdrop-blur-2xl rounded-3xl p-12 max-w-md w-full shadow-2xl border border-white/10 animate-slideUp">
                    <div className="text-center">
                        <div className="mx-auto w-28 h-28 rounded-full flex items-center justify-center mb-8 bg-red-500/30 animate-shake">
                            <div className="w-20 h-20 rounded-full flex items-center justify-center bg-red-500 animate-shake">
                                <AiOutlineClose className="text-5xl text-white" />
                            </div>
                        </div>
                        <h2 className="text-4xl font-bold mb-4 text-red-400 animate-fadeIn" style={{ animationDelay: '0.2s',fontFamily: selectedFont }}>
                            Oops !!
                        </h2>
                        <p className="text-gray-300 mb-8 text-lg animate-fadeIn" style={{ animationDelay: '0.4s',fontFamily: selectedFont }}>
                            It looks like Crypto payout methods have been enabled yet.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    if(paymentType === "fiat-payout" &&  disabledMethods?.fiatPayout) {
        return (
            <div 
                className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden"
                style={{ 
                    background: `linear-gradient(to right, ${primaryColor}, ${secondaryColor})` 
                }}
            >
                <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-red-500/30 rounded-full blur-3xl animate-pulse" />
                    <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-orange-500/30 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
                </div>
                <div className="relative bg-gray-900/60 backdrop-blur-2xl rounded-3xl p-12 max-w-md w-full shadow-2xl border border-white/10 animate-slideUp">
                    <div className="text-center">
                        <div className="mx-auto w-28 h-28 rounded-full flex items-center justify-center mb-8 bg-red-500/30 animate-shake">
                            <div className="w-20 h-20 rounded-full flex items-center justify-center bg-red-500 animate-shake">
                                <AiOutlineClose className="text-5xl text-white" />
                            </div>
                        </div>
                        <h2 className="text-4xl font-bold mb-4 text-red-400 animate-fadeIn" style={{ animationDelay: '0.2s',fontFamily: selectedFont }}>
                            Oops !!
                        </h2>
                        <p className="text-gray-300 mb-8 text-lg animate-fadeIn" style={{ animationDelay: '0.4s',fontFamily: selectedFont }}>
                            It looks like Fiat payout methods have been enabled yet.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <div 
                className="min-h-screen py-12 px-4 relative overflow-hidden"
                style={{ 
                    background: `linear-gradient(to right, ${primaryColor}, ${secondaryColor})` 
                }}
            >

                <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute top-0 left-1/4 w-96 h-96 bg-purple-500/20 rounded-full blur-3xl animate-float" />
                    <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-teal-500/20 rounded-full blur-3xl animate-float" style={{animationDelay:'2s'}} />
                    <div className="absolute top-1/2 right-0 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl animate-float" style={{animationDelay:'4s'}} />
                </div>

                <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:50px_50px]" />
                
                <div className="max-w-2xl mx-auto relative z-10">
                    <div className="flex items-center justify-between mb-8 animate-slideDown">
                        <div className="flex items-center gap-3">
                        <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-purple-500 to-purple-600 flex items-center justify-center shadow-lg shadow-purple-500/50 animate-pulse">
                            <AiOutlineLock className="text-2xl text-white" />
                        </div>
                        <h1 className="text-2xl font-bold text-white" style={{ fontFamily: selectedFont }}>Secure Checkout</h1>
                        </div>
                        {step === 2 && !addressPreview && isMultiOption && (
                        <div className="flex items-center gap-2 text-gray-300 text-sm bg-white/5 px-4 py-2 rounded-full backdrop-blur-xl border border-white/10">
                            {/* <AiOutlineLock className="text-base" />
                            <span>SSL Encrypted</span> */}
                            <button onClick={() => setStep(1)} className="text-gray-300 hover:text-white flex items-center gap-2 transition-all duration-300 text-sm hover:translate-x-[-4px] group" style={{ fontFamily: selectedFont }}>
                            <span className="group-hover:animate-bounceLeft">←</span> Back
                            </button>
                        </div>
                        )}
                    </div>
                    {step === 1 && (
                        <div className="space-y-5 animate-slideUp">
                            <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-6 border border-white/10 hover:border-white/20 transition-all duration-300 hover:shadow-xl hover:shadow-teal-500/10 group">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-3">
                                        {imagePreview && (
                                            <img
                                                src={imagePreview}
                                                alt="Business Logo Preview"
                                                className="w-12 h-12 rounded-md border border-gray-300"
                                            />
                                        )}
                                        <div>
                                            <div className="text-xs text-white uppercase tracking-wider mb-1.5" style={{ fontFamily: selectedFont }}>Merchant</div>
                                            <div className="text-white font-bold text-xl transition-colors" style={{ fontFamily: selectedFont }}>{businessName}</div>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <div className="w-2 h-2 rounded-full bg-teal-400 animate-pulse" />
                                        <div className="text-white font-bold text-2xl" style={{ fontFamily: selectedFont }}>
                                            {`${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`}
                                        </div>
                                    </div>
                                </div>
                            </div> 
                            
                            {!amountNotSet ? (
                                <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-6 border border-white/10 transition-all duration-300 hover:shadow-xl hover:shadow-teal-500/20 group" style={{ fontFamily: selectedFont }}>
                                    <div className="flex items-center justify-between">
                                    <div>
                                        <div className="text-xs text-white uppercase tracking-wider mb-2">Total Amount</div>
                                        <div className="flex items-baseline gap-2">
                                        <span className="text-white text-2xl">{getCurrencySymbol(selectedCurrency)?.icon || "$"}</span>
                                        <span className="text-white text-5xl font-bold group-hover:scale-105 transition-transform">{amount || '0.00'}</span>
                                        <span className="text-white text-lg">{selectedCurrency || "USD"}</span>
                                        </div>
                                    </div>
                                    <div className="w-12 h-12 rounded-xl bg-teal-500/20 flex items-center justify-center group-hover:scale-110 transition-transform">
                                        <AiOutlineLock className="text-2xl text-white group-hover:animate-pulse" />
                                    </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-6 border border-white/10 hover:border-white/20 transition-all duration-300 hover:shadow-xl hover:shadow-teal-500/10" style={{ fontFamily: selectedFont }}>
                                    <div className="text-xs text-white uppercase tracking-wider mb-4">Enter Amount</div>
                                    <div className="bg-white/5 rounded-xl p-5 flex items-center justify-between hover:shadow-lg transition-all duration-300 hover:scale-[1.02]">
                                    <div className="flex items-baseline gap-2 flex-1">
                                        <span className="text-white text-2xl font-medium">{getCurrencySymbol(selectedCurrency)?.icon || "$"}</span>
                                        <input type="number" value={amount} onChange={(e) => setAmount(e.target.value)} className="bg-transparent text-4xl font-bold text-white outline-none w-full transparent-input" placeholder="0.00" step="0.01" />
                                    </div>
                                    <span className="text-white text-lg font-medium">{selectedCurrency || "USD"}</span>
                                    </div>
                                </div>
                            )}

                            <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-6 border border-white/10 hover:border-white/20 transition-all duration-300">
                                <div className="text-xs text-white uppercase tracking-wider mb-4" style={{ fontFamily: selectedFont }}>Choose Payment Type</div>
                                <div className="space-y-3">
                                    {checkoutPaymentMethod == null || checkoutPaymentMethod.includes('ALL') ? (
                                        <>
                                            <button disabled={!amount} onClick={() => setPaymentType('one-time-payment')} className={`w-full bg-white/5 hover:bg-white/10 border border-white/10  rounded-xl p-4 flex items-center justify-between group transition-all duration-300 hover:scale-[1.02] hover:shadow-lg hover:shadow-teal-500/20 animate-fadeIn ${
                                                paymentType === 'one-time-payment' ? 'border-teal-500 bg-white/10 shadow-lg shadow-teal-500/30' : ''
                                                }`} style={{animationDelay:`${0*0.1}s`}}>
                                                <div className="flex items-center gap-4">
                                                <div className="w-11 h-11 rounded-xl bg-white/10 flex items-center justify-center text-white  transition-all duration-300 group-hover:scale-110 group-hover:rotate-6">
                                                    <AiOutlineCreditCard className="text-2xl" />
                                                </div>
                                                <div className="text-left">
                                                    <div className="text-white font-semibold text-base  transition-colors" style={{ fontFamily: selectedFont }}>One Time Payment</div>
                                                    <div className="text-white text-sm" style={{ fontFamily: selectedFont }} >A single payment option for a one-time transaction.</div>
                                                </div>
                                                </div>
                                                <div className={`w-5 h-5 rounded-full border-2 transition-all duration-300 ${
                                                paymentType === 'one-time-payment' ? 'border-teal-500 bg-teal-500 scale-110' : 'border-gray-500 group-hover:border-teal-400'
                                                }`}>
                                                {paymentType === 'one-time-payment' && <div className="w-full h-full flex items-center justify-center"><div className="w-2 h-2 rounded-full bg-white animate-ping-once" /></div>}
                                                </div>
                                            </button>
                                            {payinNotEnabled && (
                                                <button disabled={!amount} onClick={() => setPaymentType('pix-payment')} className={`w-full bg-white/5 hover:bg-white/10 border border-white/10  rounded-xl p-4 flex items-center justify-between group transition-all duration-300 hover:scale-[1.02] hover:shadow-lg hover:shadow-teal-500/20 animate-fadeIn ${
                                                    paymentType === 'pix-payment' ? 'border-teal-500 bg-white/10 shadow-lg shadow-teal-500/30' : ''
                                                    }`} style={{animationDelay:`${0*0.1}s`}}>
                                                    <div className="flex items-center gap-4">
                                                    <div className="w-11 h-11 rounded-xl bg-white/10 flex items-center justify-center text-white  transition-all duration-300 group-hover:scale-110 group-hover:rotate-6">
                                                        <AiOutlineQrcode className="text-2xl" />
                                                    </div>
                                                    <div className="text-left">
                                                        <div className="text-white font-semibold text-base  transition-colors" style={{ fontFamily: selectedFont }}>PIX Payment</div>
                                                        <div className="text-white text-sm" style={{ fontFamily: selectedFont }} >Use PIX for secure and instant payment.</div>
                                                    </div>
                                                    </div>
                                                    <div className={`w-5 h-5 rounded-full border-2 transition-all duration-300 ${
                                                    paymentType === 'pix-payment' ? 'border-teal-500 bg-teal-500 scale-110' : 'border-gray-500 group-hover:border-teal-400'
                                                    }`}>
                                                    {paymentType === 'pix-payment' && <div className="w-full h-full flex items-center justify-center"><div className="w-2 h-2 rounded-full bg-white animate-ping-once" /></div>}
                                                    </div>
                                                </button>
                                            )}
                                            {cryptoPayinNotEnabled && (
                                                <button disabled={!amount} onClick={() => setPaymentType('crypto')} className={`w-full bg-white/5 hover:bg-white/10 border border-white/10  rounded-xl p-4 flex items-center justify-between group transition-all duration-300 hover:scale-[1.02] hover:shadow-lg hover:shadow-teal-500/20 animate-fadeIn ${
                                                    paymentType === 'crypto' ? 'border-teal-500 bg-white/10 shadow-lg shadow-teal-500/30' : ''
                                                    }`} style={{animationDelay:`${0*0.1}s`}}>
                                                    <div className="flex items-center gap-4">
                                                    <div className="w-11 h-11 rounded-xl bg-white/10 flex items-center justify-center text-white  transition-all duration-300 group-hover:scale-110 group-hover:rotate-6">
                                                        <AiOutlineDownload className="text-2xl" />
                                                    </div>
                                                    <div className="text-left">
                                                        <div className="text-white font-semibold text-base  transition-colors" style={{ fontFamily: selectedFont }}>Crypto Payment</div>
                                                        <div className="text-white text-sm" style={{ fontFamily: selectedFont }} >Use Crypto for secure and instant payment.</div>
                                                    </div>
                                                    </div>
                                                    <div className={`w-5 h-5 rounded-full border-2 transition-all duration-300 ${
                                                    paymentType === 'crypto' ? 'border-teal-500 bg-teal-500 scale-110' : 'border-gray-500 group-hover:border-teal-400'
                                                    }`}>
                                                    {paymentType === 'crypto' && <div className="w-full h-full flex items-center justify-center"><div className="w-2 h-2 rounded-full bg-white animate-ping-once" /></div>}
                                                    </div>
                                                </button>
                                            )}  
                                            {cryptoPayoutNotEnabled && (
                                                <button disabled={!amount} onClick={() => setPaymentType('crypto-payout')} className={`w-full bg-white/5 hover:bg-white/10 border border-white/10  rounded-xl p-4 flex items-center justify-between group transition-all duration-300 hover:scale-[1.02] hover:shadow-lg hover:shadow-teal-500/20 animate-fadeIn ${
                                                    paymentType === 'crypto-payout' ? 'border-teal-500 bg-white/10 shadow-lg shadow-teal-500/30' : ''
                                                    }`} style={{animationDelay:`${0*0.1}s`}}>
                                                    <div className="flex items-center gap-4">
                                                    <div className="w-11 h-11 rounded-xl bg-white/10 flex items-center justify-center text-white  transition-all duration-300 group-hover:scale-110 group-hover:rotate-6">
                                                        <AiOutlineUpload className="text-2xl" />
                                                    </div>
                                                    <div className="text-left">
                                                        <div className="text-white font-semibold text-base  transition-colors" style={{ fontFamily: selectedFont }}>Crypto Payout</div>
                                                        <div className="text-white text-sm" style={{ fontFamily: selectedFont }} >Use Crypto Payout for secure and instant payment.</div>
                                                    </div>
                                                    </div>
                                                    <div className={`w-5 h-5 rounded-full border-2 transition-all duration-300 ${
                                                    paymentType === 'crypto-payout' ? 'border-teal-500 bg-teal-500 scale-110' : 'border-gray-500 group-hover:border-teal-400'
                                                    }`}>
                                                    {paymentType === 'crypto-payout' && <div className="w-full h-full flex items-center justify-center"><div className="w-2 h-2 rounded-full bg-white animate-ping-once" /></div>}
                                                    </div>
                                                </button>
                                            )}
                                            {fiatPayoutNotEnabled && (
                                                <button disabled={!amount} onClick={() => setPaymentType('fiat-payout')} className={`w-full bg-white/5 hover:bg-white/10 border border-white/10  rounded-xl p-4 flex items-center justify-between group transition-all duration-300 hover:scale-[1.02] hover:shadow-lg hover:shadow-teal-500/20 animate-fadeIn ${
                                                    paymentType === 'fiat-payout' ? 'border-teal-500 bg-white/10 shadow-lg shadow-teal-500/30' : ''
                                                    }`} style={{animationDelay:`${0*0.1}s`}}>
                                                    <div className="flex items-center gap-4">
                                                    <div className="w-11 h-11 rounded-xl bg-white/10 flex items-center justify-center text-white  transition-all duration-300 group-hover:scale-110 group-hover:rotate-6">
                                                        <AiOutlineBank className="text-2xl" />
                                                    </div>
                                                    <div className="text-left">
                                                        <div className="text-white font-semibold text-base  transition-colors" style={{ fontFamily: selectedFont }}>Fiat Payout</div>
                                                        <div className="text-white text-sm" style={{ fontFamily: selectedFont }} >Use Fiat Payout for secure and instant payment.</div>
                                                    </div>
                                                    </div>
                                                    <div className={`w-5 h-5 rounded-full border-2 transition-all duration-300 ${
                                                    paymentType === 'fiat-payout' ? 'border-teal-500 bg-teal-500 scale-110' : 'border-gray-500 group-hover:border-teal-400'
                                                    }`}>
                                                    {paymentType === 'fiat-payout' && <div className="w-full h-full flex items-center justify-center"><div className="w-2 h-2 rounded-full bg-white animate-ping-once" /></div>}
                                                    </div>
                                                </button>
                                            )}
                                        </>
                                    ) : (
                                        checkoutPaymentMethod.map((method: any, index: number) => {
                                            if (method === 'ONE_TIME' && (payinNotEnabled || cryptoPayinNotEnabled || cryptoPayoutNotEnabled || fiatPayoutNotEnabled)) {
                                                return (
                                                    <button disabled={!amount} onClick={() => setPaymentType('one-time-payment')} className={`w-full bg-white/5 hover:bg-white/10 border border-white/10  rounded-xl p-4 flex items-center justify-between group transition-all duration-300 hover:scale-[1.02] hover:shadow-lg hover:shadow-teal-500/20 animate-fadeIn ${
                                                    paymentType === 'one-time-payment' ? 'border-teal-500 bg-white/10 shadow-lg shadow-teal-500/30' : ''
                                                    }`} style={{animationDelay:`${0*0.1}s`}}>
                                                        <div className="flex items-center gap-4">
                                                            <div className="w-11 h-11 rounded-xl bg-white/10 flex items-center justify-center text-white  transition-all duration-300 group-hover:scale-110 group-hover:rotate-6">
                                                                <AiOutlineCreditCard className="text-2xl" />
                                                            </div>
                                                            <div className="text-left">
                                                                <div className="text-white font-semibold text-base  transition-colors" style={{ fontFamily: selectedFont }}>One Time Payment</div>
                                                                <div className="text-white text-sm" style={{ fontFamily: selectedFont }} >A single payment option for a one-time transaction.</div>
                                                            </div>
                                                        </div>
                                                        <div className={`w-5 h-5 rounded-full border-2 transition-all duration-300 ${
                                                        paymentType === 'one-time-payment' ? 'border-teal-500 bg-teal-500 scale-110' : 'border-gray-500 group-hover:border-teal-400'
                                                        }`}>
                                                            {paymentType === 'one-time-payment' && <div className="w-full h-full flex items-center justify-center"><div className="w-2 h-2 rounded-full bg-white animate-ping-once" /></div>}
                                                        </div>
                                                    </button>
                                                )
                                            }

                                            if ((method === 'PIX') && payinNotEnabled) {
                                                return (
                                                    <button disabled={!amount} onClick={() => setPaymentType('pix-payment')} className={`w-full bg-white/5 hover:bg-white/10 border border-white/10  rounded-xl p-4 flex items-center justify-between group transition-all duration-300 hover:scale-[1.02] hover:shadow-lg hover:shadow-teal-500/20 animate-fadeIn ${
                                                        paymentType === 'pix-payment' ? 'border-teal-500 bg-white/10 shadow-lg shadow-teal-500/30' : ''
                                                        }`} style={{animationDelay:`${0*0.1}s`}}>
                                                        <div className="flex items-center gap-4">
                                                            <div className="w-11 h-11 rounded-xl bg-white/10 flex items-center justify-center text-white  transition-all duration-300 group-hover:scale-110 group-hover:rotate-6">
                                                                <AiOutlineQrcode className="text-2xl" />
                                                            </div>
                                                            <div className="text-left">
                                                                <div className="text-white font-semibold text-base  transition-colors" style={{ fontFamily: selectedFont }}>PIX Payment</div>
                                                                <div className="text-white text-sm" style={{ fontFamily: selectedFont }} >Use PIX for secure and instant payment.</div>
                                                            </div>
                                                            </div>
                                                            <div className={`w-5 h-5 rounded-full border-2 transition-all duration-300 ${
                                                            paymentType === 'pix-payment' ? 'border-teal-500 bg-teal-500 scale-110' : 'border-gray-500 group-hover:border-teal-400'
                                                            }`}>
                                                            {paymentType === 'pix-payment' && <div className="w-full h-full flex items-center justify-center"><div className="w-2 h-2 rounded-full bg-white animate-ping-once" /></div>}
                                                        </div>
                                                    </button>
                                                    )
                                            }

                                            if ((method === 'CRYPTO') && cryptoPayinNotEnabled) {
                                                return (
                                                    <button disabled={!amount} onClick={() => setPaymentType('crypto')} className={`w-full bg-white/5 hover:bg-white/10 border border-white/10  rounded-xl p-4 flex items-center justify-between group transition-all duration-300 hover:scale-[1.02] hover:shadow-lg hover:shadow-teal-500/20 animate-fadeIn ${
                                                        paymentType === 'crypto' ? 'border-teal-500 bg-white/10 shadow-lg shadow-teal-500/30' : ''
                                                        }`} style={{animationDelay:`${0*0.1}s`}}>
                                                        <div className="flex items-center gap-4">
                                                        <div className="w-11 h-11 rounded-xl bg-white/10 flex items-center justify-center text-white  transition-all duration-300 group-hover:scale-110 group-hover:rotate-6">
                                                            <AiOutlineDownload className="text-2xl" />
                                                        </div>
                                                        <div className="text-left">
                                                            <div className="text-white font-semibold text-base  transition-colors" style={{ fontFamily: selectedFont }}>Crypto Payment</div>
                                                            <div className="text-white text-sm" style={{ fontFamily: selectedFont }} >Use Crypto for secure and instant payment.</div>
                                                        </div>
                                                        </div>
                                                        <div className={`w-5 h-5 rounded-full border-2 transition-all duration-300 ${
                                                        paymentType === 'crypto' ? 'border-teal-500 bg-teal-500 scale-110' : 'border-gray-500 group-hover:border-teal-400'
                                                        }`}>
                                                        {paymentType === 'crypto' && <div className="w-full h-full flex items-center justify-center"><div className="w-2 h-2 rounded-full bg-white animate-ping-once" /></div>}
                                                        </div>
                                                    </button>
                                                )
                                            }

                                            if ((method === 'CRYPTO PAYOUT') && cryptoPayoutNotEnabled) {
                                                return (
                                                    <button disabled={!amount} onClick={() => setPaymentType('crypto-payout')} className={`w-full bg-white/5 hover:bg-white/10 border border-white/10  rounded-xl p-4 flex items-center justify-between group transition-all duration-300 hover:scale-[1.02] hover:shadow-lg hover:shadow-teal-500/20 animate-fadeIn ${
                                                        paymentType === 'crypto-payout' ? 'border-teal-500 bg-white/10 shadow-lg shadow-teal-500/30' : ''
                                                        }`} style={{animationDelay:`${0*0.1}s`}}>
                                                        <div className="flex items-center gap-4">
                                                            <div className="w-11 h-11 rounded-xl bg-white/10 flex items-center justify-center text-white  transition-all duration-300 group-hover:scale-110 group-hover:rotate-6">
                                                                <AiOutlineUpload className="text-2xl" />
                                                            </div>
                                                            <div className="text-left">
                                                                <div className="text-white font-semibold text-base  transition-colors" style={{ fontFamily: selectedFont }}>Crypto Payout</div>
                                                                <div className="text-white text-sm" style={{ fontFamily: selectedFont }} >Use Crypto Payout for secure and instant payment.</div>
                                                            </div>
                                                        </div>
                                                        <div className={`w-5 h-5 rounded-full border-2 transition-all duration-300 ${
                                                        paymentType === 'crypto-payout' ? 'border-teal-500 bg-teal-500 scale-110' : 'border-gray-500 group-hover:border-teal-400'
                                                        }`}>
                                                            {paymentType === 'crypto-payout' && <div className="w-full h-full flex items-center justify-center"><div className="w-2 h-2 rounded-full bg-white animate-ping-once" /></div>}
                                                        </div>
                                                    </button>
                                                )
                                            }

                                            if ((method === 'FIAT PAYOUT') && fiatPayoutNotEnabled) {
                                                return (
                                                    <button disabled={!amount} onClick={() => setPaymentType('fiat-payout')} className={`w-full bg-white/5 hover:bg-white/10 border border-white/10  rounded-xl p-4 flex items-center justify-between group transition-all duration-300 hover:scale-[1.02] hover:shadow-lg hover:shadow-teal-500/20 animate-fadeIn ${
                                                        paymentType === 'fiat-payout' ? 'border-teal-500 bg-white/10 shadow-lg shadow-teal-500/30' : ''
                                                        }`} style={{animationDelay:`${0*0.1}s`}}>
                                                        <div className="flex items-center gap-4">
                                                            <div className="w-11 h-11 rounded-xl bg-white/10 flex items-center justify-center text-white  transition-all duration-300 group-hover:scale-110 group-hover:rotate-6">
                                                                <AiOutlineBank className="text-2xl" />
                                                            </div>
                                                            <div className="text-left">
                                                                <div className="text-white font-semibold text-base  transition-colors" style={{ fontFamily: selectedFont }}>Fiat Payout</div>
                                                                <div className="text-white text-sm" style={{ fontFamily: selectedFont }} >Use Fiat Payout for secure and instant payment.</div>
                                                            </div>
                                                        </div>
                                                        <div className={`w-5 h-5 rounded-full border-2 transition-all duration-300 ${
                                                        paymentType === 'fiat-payout' ? 'border-teal-500 bg-teal-500 scale-110' : 'border-gray-500 group-hover:border-teal-400'
                                                        }`}>
                                                            {paymentType === 'fiat-payout' && <div className="w-full h-full flex items-center justify-center"><div className="w-2 h-2 rounded-full bg-white animate-ping-once" /></div>}
                                                        </div>
                                                    </button>
                                                )
                                            }
                                        })
                                    )}
                                </div>
                                <button onClick={handleNext} disabled={!amount || parseFloat(amount) <= 0 || isExpired} className="mt-4 w-full text-white py-4 rounded-2xl font-bold text-lg  transition-all duration-300 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:shadow-none disabled:hover:scale-100 animate-fadeIn relative overflow-hidden group" style={{animationDelay:'0.4s' , backgroundColor : buttonColor , fontFamily : selectedFont}}>
                                    <span className="relative z-10">Proceed to Payment</span>
                                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />
                                </button>
                            </div>

                            <div className="flex items-center justify-center gap-2 text-white text-sm pt-4 animate-fadeIn" style={{animationDelay:'0.5s'}}>
                                <div className="flex items-center justify-center mt-6 text-sm text-white dark:text-gray-400" style={{ fontFamily: selectedFont }} >
                                    <AiOutlineLock className="text-base animate-pulse me-2" /> Powered by {mainlogo}
                                </div>
                            </div>
                        </div>
                    )}

                    {step === 2 && (
                        <div className="space-y-5 animate-slideUp">
                            <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-6 border border-white/10 hover:border-white/20 transition-all duration-300 hover:shadow-xl hover:shadow-teal-500/10 group">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-3">
                                        {imagePreview && (
                                            <img
                                                src={imagePreview}
                                                alt="Business Logo Preview"
                                                className="w-12 h-12 rounded-md border border-gray-300"
                                            />
                                        )}
                                        <div>
                                            <div className="text-xs text-white uppercase tracking-wider mb-1.5" style={{ fontFamily: selectedFont }}>Merchant</div>
                                            <div className="text-white font-bold text-xl transition-colors" style={{ fontFamily: selectedFont }}>{businessName}</div>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <div className="w-2 h-2 rounded-full bg-teal-400 animate-pulse" />
                                        <div className="text-white font-bold text-2xl" style={{ fontFamily: selectedFont }}>
                                            {`${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            {!amountNotSet ? (
                                <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-6 border border-white/10 transition-all duration-300 hover:shadow-xl hover:shadow-teal-500/20 group" style={{ fontFamily: selectedFont }}>
                                    <div className="flex items-center justify-between">
                                    <div>
                                        <div className="text-xs text-white uppercase tracking-wider mb-2">Total Amount</div>
                                        <div className="flex items-baseline gap-2">
                                        <span className="text-white text-2xl">{getCurrencySymbol(selectedCurrency)?.icon || "$"}</span>
                                        <span className="text-white text-5xl font-bold group-hover:scale-105 transition-transform">{amount || '0.00'}</span>
                                        <span className="text-white text-lg">{selectedCurrency || "USD"}</span>
                                        </div>
                                    </div>
                                    <div className="w-12 h-12 rounded-xl bg-teal-500/20 flex items-center justify-center group-hover:scale-110 transition-transform">
                                        <AiOutlineLock className="text-2xl text-white group-hover:animate-pulse" />
                                    </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-6 border border-white/10 hover:border-white/20 transition-all duration-300 hover:shadow-xl hover:shadow-teal-500/10" style={{ fontFamily: selectedFont }}>
                                    <div className="text-xs text-white uppercase tracking-wider mb-4">Enter Amount</div>
                                    <div className="bg-white/5 rounded-xl p-5 flex items-center justify-between hover:shadow-lg transition-all duration-300 hover:scale-[1.02]">
                                    <div className="flex items-baseline gap-2 flex-1">
                                        <span className="text-white text-2xl font-medium">{getCurrencySymbol(selectedCurrency)?.icon || "$"}</span>
                                        <input type="number" value={amount} onChange={(e) => setAmount(e.target.value)} className="bg-transparent text-4xl font-bold text-white outline-none w-full transparent-input" placeholder="0.00" step="0.01" />
                                    </div>
                                    <span className="text-white text-lg font-medium">{selectedCurrency || "USD"}</span>
                                    </div>
                                </div>
                            )}

                            <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-6 border border-white/10 hover:border-white/20 transition-all duration-300">
                                <div className="">
                                    {paymentType == 'one-time-payment' ? ( 
                                        <>
                                            {/* Personal Information */}
                                            <div className="grid grid-cols-3 gap-4">
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">First Name *</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={paymentData?.first_name}
                                                        onChange={(e) => handleOneFieldChange('first_name', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="John" />
                                                        {oneErrors.first_name && <span className="text-white text-sm">{oneErrors.first_name}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Middle Name *</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={paymentData?.middle_name}
                                                        onChange={(e) => handleOneFieldChange('middle_name', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="G" />
                                                        {oneErrors.middle_name && <span className="text-white text-sm">{oneErrors.middle_name}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Last Name *</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={paymentData?.last_name}
                                                        onChange={(e) => handleOneFieldChange('last_name', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="Doe" />
                                                        {oneErrors.last_name && <span className="text-white text-sm">{oneErrors.last_name}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-3 gap-4 mt-4">
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Email *</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        autoComplete='off'
                                                        style={{ fontFamily: selectedFont }}
                                                        value={paymentData?.email}
                                                        onChange={(e) => handleOneFieldChange('email', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="test@gmail.com" />
                                                        {oneErrors.email && <span className="text-white text-sm">{oneErrors.email}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Phone Number *</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={paymentData?.phone}
                                                        onChange={(e) => handleOneFieldChange('phone', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="123457890" />
                                                        {oneErrors.phone && <span className="text-white text-sm">{oneErrors.phone}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Currency *</label>
                                                    <div className="relative">
                                                        <AntSelect
                                                            showSearch
                                                            placeholder="Select currency"
                                                            optionFilterProp="children"
                                                            filterOption={(input, option) =>
                                                                (option?.label ?? "").includes(
                                                                input?.toUpperCase()
                                                                )
                                                            }
                                                            filterSort={(optionA, optionB) =>
                                                                (optionA?.label ?? "")
                                                                .toLowerCase()
                                                                .localeCompare(
                                                                    (
                                                                    optionB?.label ?? ""
                                                                    ).toLowerCase()
                                                                )
                                                            }
                                                            className={`w-full h-[54px] bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                            options={currencyCodes.map(
                                                                (currencyCode) => {
                                                                const currencyDetails =
                                                                    getCurrencySymbol(currencyCode);
                                                                return {
                                                                    value: currencyCode,
                                                                    label: `${currencyCode}: ${currencyDetails.title?.toUpperCase()}`,
                                                                };
                                                                }
                                                            )}
                                                            onChange={(e) => {
                                                                hanldleCurrenyChange(
                                                                e,
                                                                );
                                                            }}
                                                            value={selectedCurrency}
                                                            notFoundContent={"No options found"}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            {/* Card Information */}
                                            <div className="animate-fadeIn mt-4" style={{animationDelay:'0.1s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Card Number *</label>
                                                <div className="relative">
                                                    {/* <AiOutlineCreditCard className="absolute left-4 top-1/2 -translate-y-1/2 text-white text-xl" /> */}
                                                    <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={paymentData?.cardNumber}
                                                        onChange={handleCardNumberChange}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="1234 5678 9012 3456" 
                                                        />
                                                    {oneErrors.cardNumber && <span className="text-white text-sm">{oneErrors.cardNumber}</span>}
                                                </div>
                                            </div>
                                            <div className="animate-fadeIn mt-4" style={{animationDelay:'0.1s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Cardholder Name*</label>
                                                <div className="relative">
                                                    {/* <AiOutlineUser className="absolute left-4 top-1/2 -translate-y-1/2 text-white text-xl" /> */}
                                                    <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={paymentData?.cardHolderName}
                                                        onChange={(e) => handleOneFieldChange('cardHolderName', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="Card Holder Name" />
                                                    {oneErrors.cardHolderName && <span className="text-white text-sm">{oneErrors.cardHolderName}</span>}
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-2 gap-4 mt-4">
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Expiry Date *</label>
                                                    <div className="relative">
                                                        {/* <AiOutlineCreditCard className="absolute left-4 top-1/2 -translate-y-1/2 text-white text-xl" /> */}
                                                        <input 
                                                        type="text" 
                                                        autoComplete='off'
                                                        style={{ fontFamily: selectedFont }}
                                                        value={paymentData?.expiry}
                                                        onChange={handleExpiryDateChange}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="MM / YY" />
                                                        {oneErrors.expiry && <span className="text-white text-sm">{oneErrors.expiry}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.3s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">CVV *</label>
                                                    <div className="relative">
                                                        {/* <AiOutlineLock className="absolute left-4 top-1/2 -translate-y-1/2 text-white text-xl" /> */}
                                                        <input 
                                                            type="password" 
                                                            autoComplete='off'
                                                            style={{ fontFamily: selectedFont }}
                                                            value={paymentData?.cvv}
                                                            onChange={handleCvvChange}
                                                            className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                            placeholder="•••" />
                                                        {oneErrors.cvv && <span className="text-white text-sm">{oneErrors.cvv}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Address Information */}
                                            <div className="animate-fadeIn mt-4" style={{animationDelay:'0.1s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Address *</label>
                                                <div className="relative">
                                                    <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={paymentData?.address}
                                                        onChange={(e) => handleOneFieldChange('address', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="Address"
                                                        />
                                                    {oneErrors.address && <span className="text-white text-sm">{oneErrors.address}</span>}
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-2 gap-4 mt-4">
                                                <div className="animate-fadeIn" style={{animationDelay:'0.1s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">State *</label>
                                                    <div className="relative">
                                                        <input 
                                                            type="text" 
                                                            style={{ fontFamily: selectedFont }}
                                                            value={paymentData?.state}
                                                            onChange={(e) => handleOneFieldChange('state', e.target.value)}
                                                            className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                            placeholder="State"
                                                            />
                                                        {oneErrors.state && <span className="text-white text-sm">{oneErrors.state}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.1s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">City *</label>
                                                    <div className="relative">
                                                        <input 
                                                            type="text" 
                                                            style={{ fontFamily: selectedFont }}
                                                            value={paymentData?.city}
                                                            onChange={(e) => handleOneFieldChange('city', e.target.value)}
                                                            className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                            placeholder="city"
                                                            />
                                                        {oneErrors.city && <span className="text-white text-sm">{oneErrors.city}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-2 gap-4 mt-4">
                                                <div className="animate-fadeIn" style={{animationDelay:'0.1s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Postal Code *</label>
                                                    <div className="relative">
                                                        <input 
                                                            type="text" 
                                                            style={{ fontFamily: selectedFont }}
                                                            value={paymentData?.postalCode}
                                                            onChange={(e) => handleOneFieldChange('postalCode', e.target.value)}
                                                            className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                            placeholder="Postal Code"
                                                            />
                                                        {oneErrors.postalCode && <span className="text-white text-sm">{oneErrors.postalCode}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.1s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Country *</label>
                                                    <div className="relative">
                                                        <select
                                                            className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                            onChange={handleCountryChange}
                                                            style={{ fontFamily: selectedFont }}
                                                            value={paymentData?.country}
                                                            >
                                                            {allCountries.map((country) => (
                                                                <option key={country.code} value={country.code} className="text-black">
                                                                {country.name}
                                                                </option>
                                                            ))}
                                                            </select>
                                                        {oneErrors.country && <span className="text-white text-sm">{oneErrors.country}</span>}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Pay Now button */}
                                            <button onClick={handlePayNow} disabled={!amount || parseFloat(amount) <= 0 || isExpired || isLoading} className="w-full text-white py-4 mt-4 rounded-2xl font-bold text-lg hover:shadow-2xl hover:shadow-teal-500/50 transition-all duration-300 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:shadow-none disabled:hover:scale-100 animate-fadeIn relative overflow-hidden group" style={{animationDelay:'0.4s' , backgroundColor : buttonColor, fontFamily : selectedFont}}>
                                                <span className="relative z-10">Pay Now</span>
                                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />
                                            </button>
                                        </>  
                                    ): paymentType === 'pix-payment' ? (
                                        <>
                                            <div className="grid grid-cols-2 gap-4">
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">First Name *</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={pixPaymentData?.first_name}
                                                        onChange={(e) => handlePixFieldChange('first_name', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="John" />
                                                        {pixErrors.first_name && <span className="text-white text-sm">{pixErrors.first_name}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Last Name *</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={pixPaymentData?.last_name}
                                                        onChange={(e) => handlePixFieldChange('last_name', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="Doe" />
                                                        {pixErrors.last_name && <span className="text-white text-sm">{pixErrors.last_name}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-2 gap-4 mt-4">
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Identification Number *</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={pixPaymentData?.identification_number}
                                                        onChange={(e) => handlePixFieldChange('identification_number', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="Identification Number" />
                                                        {pixErrors.identification_number && <span className="text-white text-sm">{pixErrors.identification_number}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Identification Type *</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={pixPaymentData?.identification_type}
                                                        onChange={(e) => handlePixFieldChange('identification_type', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="Identification Type" />
                                                        {pixErrors.identification_type && <span className="text-white text-sm">{pixErrors.identification_type}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            <button onClick={handlePayNow} disabled={isExpired || isLoading} className="w-full text-white py-4 mt-4 rounded-2xl font-bold text-lg hover:shadow-2xl hover:shadow-teal-500/50 transition-all duration-300 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:shadow-none disabled:hover:scale-100 animate-fadeIn relative overflow-hidden group" style={{animationDelay:'0.4s' , backgroundColor : buttonColor, fontFamily : selectedFont}}>
                                                <span className="relative z-10">Pay Now</span>
                                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />
                                            </button>
                                        </>  
                                    ): paymentType === 'crypto' ? (
                                        <>
                                            <div className="grid grid-cols-2 gap-4">
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">First Name *</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={cryptoPaymentData?.first_name}
                                                        onChange={(e) => handleCryptoFieldChange('first_name', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="John" />
                                                        {cryptoErrors.first_name && <span className="text-white text-sm">{cryptoErrors.first_name}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Last Name *</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={cryptoPaymentData?.last_name}
                                                        onChange={(e) => handleCryptoFieldChange('last_name', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="Doe" />
                                                        {cryptoErrors.last_name && <span className="text-white text-sm">{cryptoErrors.last_name}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-3 gap-4 mt-4">
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Email *</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        autoComplete='off'
                                                        style={{ fontFamily: selectedFont }}
                                                        value={cryptoPaymentData?.email}
                                                        onChange={(e) => handleCryptoFieldChange('email', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="test@gmail.com" />
                                                        {cryptoErrors.email && <span className="text-white text-sm">{cryptoErrors.email}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Phone Number *</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={cryptoPaymentData?.phone}
                                                        onChange={(e) => handleCryptoFieldChange('phone', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="123457890" />
                                                        {cryptoErrors.phone && <span className="text-white text-sm">{cryptoErrors.phone}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Country *</label>
                                                    <div className="relative">
                                                        <select
                                                            className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                            onChange={handleCryptoCountryChange}
                                                            style={{ fontFamily: selectedFont }}
                                                            value={cryptoPaymentData?.country}
                                                            >
                                                            {allCountries.map((country) => (
                                                                <option key={country.code} value={country.code} className="text-black">
                                                                {country.name}
                                                                </option>
                                                            ))}
                                                            </select>
                                                        {cryptoErrors.country && <span className="text-white text-sm">{cryptoErrors.country}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-2 gap-4 mt-4">
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Crypto Currency </label>
                                                    <div className="relative">
                                                        <select
                                                            className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                            onChange={handleCryptoCurrencyChangeNormal}
                                                            style={{ fontFamily: selectedFont }}
                                                            value={cryptoPaymentData?.crypto_currency}
                                                            disabled={addressPreview}
                                                            >
                                                            {allCryptoCurrency.map((currency : any) => (
                                                                <option key={currency.code} value={currency.code} className="text-black">
                                                                {currency.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {cryptoErrors.crypto_currency && <span className="text-white text-sm">{cryptoErrors.crypto_currency}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Blockchain Network *</label>
                                                    <div className="relative">
                                                        <select
                                                            className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                            onChange={handleBlockChainChange}
                                                            style={{ fontFamily: selectedFont }}
                                                            value={cryptoPaymentData?.blockchain_network}
                                                            disabled={addressPreview}
                                                            >
                                                            {blockChainNetworks.map((network : any) => (
                                                                <option key={network.code} value={network.code} className="text-black">
                                                                {network.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {cryptoErrors.blockchain_network && <span className="text-white text-sm">{cryptoErrors.blockchain_network}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            {!addressPreview ? (
                                                <button onClick={handlePayNow} disabled={isExpired || isLoading} className="w-full text-white py-4 mt-4 rounded-2xl font-bold text-lg hover:shadow-2xl hover:shadow-teal-500/50 transition-all duration-300 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:shadow-none disabled:hover:scale-100 animate-fadeIn relative overflow-hidden group" style={{animationDelay:'0.4s' , backgroundColor : buttonColor, fontFamily : selectedFont}}>
                                                    <span className="relative z-10">Generate Address</span>
                                                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />
                                                </button>

                                            ) : (
                                                <>
                                                    <div className="animate-fadeIn mt-4" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}>
                                                        <div className="flex flex-col">
                                                            <label
                                                                className="mb-2 text-sm font-medium  flex justify-between items-center"
                                                                style={{ fontFamily: selectedFont }}
                                                            >
                                                                <span className='text-white text-sm'>Deposit Address</span>
                                                            </label>
                                                            <div className={`border ${getBorderRadiusCardClass()} border-gray-100 dark:border-white/10 focus-within:ring-2 focus-within:ring-blue-500 transition-all shadow-sm hover:shadow-lg transition-shadow`}>
                                                                <div className="grid grid-cols-[1fr_3fr] gap-2">
                                                                    <div className="p-4 flex justify-center">
                                                                        <QRCodeCanvas value={qrCode} size={170} level="H" />
                                                                    </div>
                                                                    <div className="p-4">
                                                                        <h4 className="font-extrabold text-sm text-white">
                                                                            {selectedCryptoCurrency} ({cryptoPaymentData.blockchain_network}) Address
                                                                        </h4>
                                                                        <div className="w-full p-2 mt-2 rounded bg-white/10">
                                                                            <div className="flex items-center justify-between">
                                                                                <h4 className="font-semibold text-lg text-white break-all">
                                                                                    {cryptoAddress}
                                                                                </h4>
                                                                                {copiedAddress ? (
                                                                                    <BsCheck className="h-5 w-5 text-white" />
                                                                                ) : (
                                                                                    <BsCopy
                                                                                        className="h-5 w-5 cursor-pointer text-white"
                                                                                        onClick={handleCopyAddress}
                                                                                    />
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <div className="w-full p-2 mt-2 rounded bg-white/10">
                                                                            <div className="flex items-center justify-between">
                                                                                <h4 className="font-semibold text-lg text-white">
                                                                                    = {cryptoAmount} {cryptoPaymentData.crypto_currency}
                                                                                </h4>
                                                                                {copiedAmount ? (
                                                                                    <BsCheck className="h-5 w-5 text-white" />
                                                                                ) : (
                                                                                    <BsCopy
                                                                                        className="h-5 w-5 cursor-pointer text-white"
                                                                                        onClick={handleCopyAmount}
                                                                                    />
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="w-full p-4">
                                                                    <div className="font-medium text-white  bg-white/10 rounded p-4">
                                                                        You must ensure that you are sending <span className="font-bold">on the selected network</span> otherwise your assets/funds will be lost.
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </>  
                                    ): paymentType === 'crypto-payout' ? (
                                        <>
                                            <div className="grid grid-cols-2 gap-4">
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">First Name *</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={cryptoPayoutPaymentData?.first_name}
                                                        onChange={(e) => handleCryptoPayoutFieldChange('first_name', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="John" />
                                                        {cryptoPayoutErrors.first_name && <span className="text-white text-sm">{cryptoPayoutErrors.first_name}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Last Name *</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={cryptoPayoutPaymentData?.last_name}
                                                        onChange={(e) => handleCryptoPayoutFieldChange('last_name', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="Doe" />
                                                        {cryptoPayoutErrors.last_name && <span className="text-white text-sm">{cryptoPayoutErrors.last_name}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-2 gap-4 mt-4">
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Email *</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        autoComplete='off'
                                                        style={{ fontFamily: selectedFont }}
                                                        value={cryptoPayoutPaymentData?.email}
                                                        onChange={(e) => handleCryptoPayoutFieldChange('email', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="test@gmail.com" />
                                                        {cryptoPayoutErrors.email && <span className="text-white text-sm">{cryptoPayoutErrors.email}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Phone Number *</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={cryptoPayoutPaymentData?.phone}
                                                        onChange={(e) => handleCryptoPayoutFieldChange('phone', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="123457890" />
                                                        {cryptoPayoutErrors.phone && <span className="text-white text-sm">{cryptoPayoutErrors.phone}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="animate-fadeIn mt-4" style={{animationDelay:'0.1s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Address * </label>
                                                <div className="relative">
                                                    <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={cryptoPayoutPaymentData?.address}
                                                        onChange={(e) => handleCryptoPayoutFieldChange('address', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="Address"
                                                        />
                                                    {cryptoPayoutErrors.address && <span className="text-white text-sm">{cryptoPayoutErrors.address}</span>}
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-2 gap-4 mt-4">
                                                <div className="animate-fadeIn" style={{animationDelay:'0.1s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">State *</label>
                                                    <div className="relative">
                                                        <input 
                                                            type="text" 
                                                            style={{ fontFamily: selectedFont }}
                                                            value={cryptoPayoutPaymentData?.state}
                                                            onChange={(e) => handleCryptoPayoutFieldChange('state', e.target.value)}
                                                            className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                            placeholder="State"
                                                            />
                                                        {cryptoPayoutErrors.state && <span className="text-white text-sm">{cryptoPayoutErrors.state}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.1s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">City *</label>
                                                    <div className="relative">
                                                        <input 
                                                            type="text" 
                                                            style={{ fontFamily: selectedFont }}
                                                            value={cryptoPayoutPaymentData?.city}
                                                            onChange={(e) => handleCryptoPayoutFieldChange('city', e.target.value)}
                                                            className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                            placeholder="city"
                                                            />
                                                        {cryptoPayoutErrors.city && <span className="text-white text-sm">{cryptoPayoutErrors.city}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-2 gap-4 mt-4">
                                                <div className="animate-fadeIn" style={{animationDelay:'0.1s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Postal Code *</label>
                                                    <div className="relative">
                                                        <input 
                                                            type="text" 
                                                            style={{ fontFamily: selectedFont }}
                                                            value={cryptoPayoutPaymentData?.postal_code}
                                                            onChange={(e) => handleCryptoPayoutFieldChange('postal_code', e.target.value)}
                                                            className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                            placeholder="Postal Code"
                                                            />
                                                        {cryptoPayoutErrors.postal_code && <span className="text-white text-sm">{cryptoPayoutErrors.postal_code}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.1s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Country *</label>
                                                    <div className="relative">
                                                        <select
                                                            className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                            onChange={handleCryptoPayoutCountryChange}
                                                            style={{ fontFamily: selectedFont }}
                                                            value={cryptoPayoutPaymentData?.country}
                                                            >
                                                            {allCountries.map((country) => (
                                                                <option key={country.code} value={country.code} className="text-black">
                                                                {country.name}
                                                                </option>
                                                            ))}
                                                            </select>
                                                        {cryptoPayoutErrors.country && <span className="text-white text-sm">{cryptoPayoutErrors.country}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-3 gap-4 mt-4">
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Crypto Currency *</label>
                                                    <div className="relative">
                                                        <select
                                                            className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                            onChange={handleCryptoCurrencyChangeNormalPayout}
                                                            style={{ fontFamily: selectedFont }}
                                                            value={cryptoPayoutPaymentData?.crypto_currency}
                                                            disabled={addressPreview}
                                                            >
                                                            {allCryptoCurrency.map((currency : any) => (
                                                                <option key={currency.code} value={currency.code} className="text-black">
                                                                {currency.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {cryptoPayoutErrors.crypto_currency && <span className="text-white text-sm">{cryptoPayoutErrors.crypto_currency}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Blockchain Network/Chain *</label>
                                                    <div className="relative">
                                                        <select
                                                            className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                            onChange={handleBlockChainChangePayout}
                                                            style={{ fontFamily: selectedFont }}
                                                            value={cryptoPayoutPaymentData?.blockchain_network}
                                                            disabled={addressPreview}
                                                            >
                                                            {blockChainNetworks.map((network : any) => (
                                                                <option key={network.code} value={network.code} className="text-black">
                                                                {network.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {cryptoPayoutErrors.blockchain_network && <span className="text-white text-sm">{cryptoPayoutErrors.blockchain_network}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Wallet Address *</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={cryptoPayoutPaymentData?.wallet_address}
                                                        onChange={(e) => handleCryptoPayoutFieldChange('wallet_address', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="John" />
                                                        {cryptoPayoutErrors.wallet_address && <span className="text-white text-sm">{cryptoPayoutErrors.wallet_address}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            <button onClick={handlePayNow} disabled={!amount || parseFloat(amount) <= 0 || isExpired || isLoading} className="w-full text-white py-4 mt-4 rounded-2xl font-bold text-lg hover:shadow-2xl hover:shadow-teal-500/50 transition-all duration-300 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:shadow-none disabled:hover:scale-100 animate-fadeIn relative overflow-hidden group" style={{animationDelay:'0.4s' , backgroundColor : buttonColor, fontFamily : selectedFont}}>
                                                <span className="relative z-10">Pay Now</span>
                                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />
                                            </button>
                                        </>  
                                    ): paymentType === 'fiat-payout' ? (
                                        <>
                                            <div className="grid grid-cols-2 gap-4">
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">First Name *</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={fiatPayoutPaymentData?.first_name}
                                                        onChange={(e) => handleFiatPayoutFieldChange('first_name', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="John" />
                                                        {fiatPayoutErrors.first_name && <span className="text-white text-sm">{fiatPayoutErrors.first_name}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Last Name *</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={fiatPayoutPaymentData?.last_name}
                                                        onChange={(e) => handleFiatPayoutFieldChange('last_name', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="Doe" />
                                                        {fiatPayoutErrors.last_name && <span className="text-white text-sm">{fiatPayoutErrors.last_name}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-2 gap-4 mt-4">
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Email *</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        autoComplete='off'
                                                        style={{ fontFamily: selectedFont }}
                                                        value={fiatPayoutPaymentData?.email}
                                                        onChange={(e) => handleFiatPayoutFieldChange('email', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="test@gmail.com" />
                                                        {fiatPayoutErrors.email && <span className="text-white text-sm">{fiatPayoutErrors.email}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Phone Number *</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={fiatPayoutPaymentData?.phone}
                                                        onChange={(e) => handleFiatPayoutFieldChange('phone', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="123457890" />
                                                        {fiatPayoutErrors.phone && <span className="text-white text-sm">{fiatPayoutErrors.phone}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="animate-fadeIn mt-4" style={{animationDelay:'0.1s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Address *</label>
                                                <div className="relative">
                                                    <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={fiatPayoutPaymentData?.address}
                                                        onChange={(e) => handleFiatPayoutFieldChange('address', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="Address"
                                                        />
                                                    {fiatPayoutErrors.address && <span className="text-white text-sm">{fiatPayoutErrors.address}</span>}
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-2 gap-4 mt-4">
                                                <div className="animate-fadeIn" style={{animationDelay:'0.1s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">State *</label>
                                                    <div className="relative">
                                                        <input 
                                                            type="text" 
                                                            style={{ fontFamily: selectedFont }}
                                                            value={fiatPayoutPaymentData?.state}
                                                            onChange={(e) => handleFiatPayoutFieldChange('state', e.target.value)}
                                                            className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                            placeholder="State"
                                                            />
                                                        {fiatPayoutErrors.state && <span className="text-white text-sm">{fiatPayoutErrors.state}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.1s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">City *</label>
                                                    <div className="relative">
                                                        <input 
                                                            type="text" 
                                                            style={{ fontFamily: selectedFont }}
                                                            value={fiatPayoutPaymentData?.city}
                                                            onChange={(e) => handleFiatPayoutFieldChange('city', e.target.value)}
                                                            className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                            placeholder="city"
                                                            />
                                                        {fiatPayoutErrors.city && <span className="text-white text-sm">{fiatPayoutErrors.city}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-2 gap-4 mt-4">
                                                <div className="animate-fadeIn" style={{animationDelay:'0.1s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Postal Code *</label>
                                                    <div className="relative">
                                                        <input 
                                                            type="text" 
                                                            style={{ fontFamily: selectedFont }}
                                                            value={fiatPayoutPaymentData?.postal_code}
                                                            onChange={(e) => handleFiatPayoutFieldChange('postal_code', e.target.value)}
                                                            className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                            placeholder="Postal Code"
                                                            />
                                                        {fiatPayoutErrors.postal_code && <span className="text-white text-sm">{fiatPayoutErrors.postal_code}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.1s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Country *</label>
                                                    <div className="relative">
                                                        <select
                                                            className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                            onChange={handleFiatPayoutCountryChange}
                                                            style={{ fontFamily: selectedFont }}
                                                            value={fiatPayoutPaymentData?.country}
                                                            >
                                                            {allCountries.map((country) => (
                                                                <option key={country.code} value={country.code} className="text-black">
                                                                {country.name}
                                                                </option>
                                                            ))}
                                                            </select>
                                                        {fiatPayoutErrors.country && <span className="text-white text-sm">{fiatPayoutErrors.country}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-3 gap-4 mt-4">
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Document Number</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={fiatPayoutPaymentData?.document_number}
                                                        onChange={(e) => handleFiatPayoutFieldChange('document_number', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="123456790-5" />
                                                        {fiatPayoutErrors.document_number && <span className="text-white text-sm">{fiatPayoutErrors.document_number}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Bank Account</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={fiatPayoutPaymentData?.bank_account}
                                                        onChange={(e) => handleFiatPayoutFieldChange('bank_account', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="706180269957590006" />
                                                        {fiatPayoutErrors.bank_account && <span className="text-white text-sm">{fiatPayoutErrors.bank_account}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Bank Code</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={fiatPayoutPaymentData?.bank_code}
                                                        onChange={(e) => handleFiatPayoutFieldChange('bank_code', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="51" />
                                                        {fiatPayoutErrors.bank_code && <span className="text-white text-sm">{fiatPayoutErrors.bank_code}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-3 gap-4 mt-4">
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Account Type</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={fiatPayoutPaymentData?.account_type}
                                                        onChange={(e) => handleFiatPayoutFieldChange('account_type', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="CTD" />
                                                        {fiatPayoutErrors.account_type && <span className="text-white text-sm">{fiatPayoutErrors.account_type}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Currency</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={fiatPayoutPaymentData?.currency}
                                                        onChange={(e) => handleFiatPayoutFieldChange('currency', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="MXN" />
                                                        {fiatPayoutErrors.currency && <span className="text-white text-sm">{fiatPayoutErrors.currency}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Fiat Currency</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={fiatPayoutPaymentData?.fiat_currency}
                                                        onChange={(e) => handleFiatPayoutFieldChange('fiat_currency', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="MXN" />
                                                        {fiatPayoutErrors.fiat_currency && <span className="text-white text-sm">{fiatPayoutErrors.fiat_currency}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-2 gap-4 mt-4">
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Block Chain Symbol</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={fiatPayoutPaymentData?.blockchain_symbol}
                                                        onChange={(e) => handleFiatPayoutFieldChange('blockchain_symbol', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="POL" />
                                                        {fiatPayoutErrors.blockchain_symbol && <span className="text-white text-sm">{fiatPayoutErrors.blockchain_symbol}</span>}
                                                    </div>
                                                </div>
                                                <div className="animate-fadeIn" style={{animationDelay:'0.2s' , fontFamily: selectedFont}}><label className="block text-white text-sm mb-2.5">Token Symbol</label>
                                                    <div className="relative">
                                                        <input 
                                                        type="text" 
                                                        style={{ fontFamily: selectedFont }}
                                                        value={fiatPayoutPaymentData?.token_symbol}
                                                        onChange={(e) => handleFiatPayoutFieldChange('token_symbol', e.target.value)}
                                                        className={`w-full bg-white/5 border ${getBorderRadiusCardClass()}  border-white/10 px-4 py-4 text-white placeholder-gray-100 focus:border-white focus:outline-none transition-all duration-300 focus:scale-[1.02] focus:shadow-lg focus:shadow-teal-500/20`}
                                                        placeholder="USDC" />
                                                        {fiatPayoutErrors.token_symbol && <span className="text-white text-sm">{fiatPayoutErrors.token_symbol}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            <button onClick={handlePayNow} disabled={!amount || parseFloat(amount) <= 0 || isExpired || isLoading} className="w-full text-white py-4 mt-4 rounded-2xl font-bold text-lg hover:shadow-2xl hover:shadow-teal-500/50 transition-all duration-300 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:shadow-none disabled:hover:scale-100 animate-fadeIn relative overflow-hidden group" style={{animationDelay:'0.4s' , backgroundColor : buttonColor , fontFamily : selectedFont}}>
                                                <span className="relative z-10">Pay Now</span>
                                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />
                                            </button>
                                        </>  
                                    ): (
                                        <></>  
                                    )}
                                </div>
                            </div>

                            <div className="flex items-center justify-center gap-2 text-white text-sm pt-4 animate-fadeIn" style={{animationDelay:'0.5s'}}>
                                <div className="flex items-center justify-center mt-6 text-sm text-white dark:text-gray-400" style={{ fontFamily: selectedFont }} >
                                    <AiOutlineLock className="text-base animate-pulse me-2" /> Powered by {mainlogo}
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <style>{`
                    @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
                    @keyframes slideUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
                    @keyframes slideDown { from { opacity: 0; transform: translateY(-20px); } to { opacity: 1; transform: translateY(0); } }
                    @keyframes scaleIn { from { opacity: 0; transform: scale(0.8); } to { opacity: 1; transform: scale(1); } }
                    @keyframes float { 0%, 100% { transform: translate(0, 0); } 50% { transform: translate(30px, -30px); } }
                    @keyframes shake { 0%, 100% { transform: translateX(0); } 25% { transform: translateX(-10px); } 75% { transform: translateX(10px); } }
                    @keyframes checkmark { from { transform: scale(0) rotate(-45deg); } to { transform: scale(1) rotate(0); } }
                    @keyframes ping-once { 75%, 100% { transform: scale(1.2); opacity: 0; } }
                    @keyframes bounceLeft { 0%, 100% { transform: translateX(0); } 50% { transform: translateX(-5px); } }
                    @keyframes spin-reverse { from { transform: rotate(360deg); } to { transform: rotate(0deg); } }
                    @keyframes bounce-slow { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
                    @keyframes orbit { from { transform: rotate(0deg) translateX(80px) rotate(0deg); } to { transform: rotate(360deg) translateX(80px) rotate(-360deg); } }
                    .animate-slideUp { animation: slideUp 0.5s ease-out; }
                    .animate-slideDown { animation: slideDown 0.6s ease-out; }
                    .animate-scaleIn { animation: scaleIn 0.5s ease-out; }
                    .animate-fadeIn { animation: fadeIn 0.5s ease-out; }
                    .animate-float { animation: float 6s ease-in-out infinite; }
                    .animate-shake { animation: shake 0.5s ease-in-out; }
                    .animate-checkmark { animation: checkmark 0.5s ease-out; }
                    .animate-ping-once { animation: ping-once 1s cubic-bezier(0, 0, 0.2, 1); }
                    .animate-bounceLeft { animation: bounceLeft 0.5s ease-in-out infinite; }
                    .animate-spin-reverse { animation: spin-reverse 2s linear infinite; }
                    .animate-bounce-slow { animation: bounce-slow 2s ease-in-out infinite; }
                    .animate-orbit { animation: orbit 3s linear infinite; }
                    input[type="number"]::-webkit-inner-spin-button, 
                    input[type="number"]::-webkit-outer-spin-button { 
                        -webkit-appearance: none; 
                        margin: 0; 
                    }
                    input[type="number"] { 
                        -moz-appearance: textfield; 
                    }
                    
                    .transparent-input {
                        background: transparent !important;
                        background-color: transparent !important;
                        border: none !important;
                        box-shadow: none !important;
                    }
                    
                    .transparent-input:focus {
                        background: transparent !important;
                        background-color: transparent !important;
                        border: none !important;
                        box-shadow: none !important;
                    }
                    
                    .transparent-input::placeholder {
                        color: rgba(255, 255, 255, 0.3);
                    }
                    .ant-select-selector{ border : none !important ; background : transparent !important; color : white !important;}
                `}</style>
            </div>
        </>
    )
}

export default CheckoutPage